@file:Suppress("unused", "SpellCheckingInspection")

package xim.poc.game.configuration.constants

val itemFireCrystal_4096 = ItemSkillId(4096)
val itemIceCrystal_4097 = ItemSkillId(4097)
val itemWindCrystal_4098 = ItemSkillId(4098)
val itemEarthCrystal_4099 = ItemSkillId(4099)
val itemLightngCrystal_4100 = ItemSkillId(4100)
val itemWaterCrystal_4101 = ItemSkillId(4101)
val itemLightCrystal_4102 = ItemSkillId(4102)
val itemDarkCrystal_4103 = ItemSkillId(4103)
val itemFireCluster_4104 = ItemSkillId(4104)
val itemIceCluster_4105 = ItemSkillId(4105)
val itemWindCluster_4106 = ItemSkillId(4106)
val itemEarthCluster_4107 = ItemSkillId(4107)
val itemLightningCluster_4108 = ItemSkillId(4108)
val itemWaterCluster_4109 = ItemSkillId(4109)
val itemLightCluster_4110 = ItemSkillId(4110)
val itemDarkCluster_4111 = ItemSkillId(4111)
val itemPotion_4112 = ItemSkillId(4112)
val itemPotion1_4113 = ItemSkillId(4113)
val itemPotion2_4114 = ItemSkillId(4114)
val itemPotion3_4115 = ItemSkillId(4115)
val itemHiPotion_4116 = ItemSkillId(4116)
val itemHiPotion1_4117 = ItemSkillId(4117)
val itemHiPotion2_4118 = ItemSkillId(4118)
val itemHiPotion3_4119 = ItemSkillId(4119)
val itemXPotion_4120 = ItemSkillId(4120)
val itemXPotion1_4121 = ItemSkillId(4121)
val itemXPotion2_4122 = ItemSkillId(4122)
val itemXPotion3_4123 = ItemSkillId(4123)
val itemMaxPotion_4124 = ItemSkillId(4124)
val itemMaxPotion1_4125 = ItemSkillId(4125)
val itemMaxPotion2_4126 = ItemSkillId(4126)
val itemMaxPotion3_4127 = ItemSkillId(4127)
val itemEther_4128 = ItemSkillId(4128)
val itemEther1_4129 = ItemSkillId(4129)
val itemEther2_4130 = ItemSkillId(4130)
val itemEther3_4131 = ItemSkillId(4131)
val itemHiEther_4132 = ItemSkillId(4132)
val itemHiEther1_4133 = ItemSkillId(4133)
val itemHiEther2_4134 = ItemSkillId(4134)
val itemHiEther3_4135 = ItemSkillId(4135)
val itemSuperEther_4136 = ItemSkillId(4136)
val itemSuperEther1_4137 = ItemSkillId(4137)
val itemSuperEther2_4138 = ItemSkillId(4138)
val itemSuperEther3_4139 = ItemSkillId(4139)
val itemProEther_4140 = ItemSkillId(4140)
val itemProEther1_4141 = ItemSkillId(4141)
val itemProEther2_4142 = ItemSkillId(4142)
val itemProEther3_4143 = ItemSkillId(4143)
val itemHiElixir_4144 = ItemSkillId(4144)
val itemElixir_4145 = ItemSkillId(4145)
val itemRevitalizer_4146 = ItemSkillId(4146)
val itemBodyBoost_4147 = ItemSkillId(4147)
val itemAntidote_4148 = ItemSkillId(4148)
val itemPanacea_4149 = ItemSkillId(4149)
val itemEyeDrops_4150 = ItemSkillId(4150)
val itemEchoDrops_4151 = ItemSkillId(4151)
val itemAntacid_4153 = ItemSkillId(4153)
val itemHolyWater_4154 = ItemSkillId(4154)
val itemRemedy_4155 = ItemSkillId(4155)
val itemMulsum_4156 = ItemSkillId(4156)
val itemPoisonPotion_4157 = ItemSkillId(4157)
val itemVenomPotion_4158 = ItemSkillId(4158)
val itemParalyzePotion_4159 = ItemSkillId(4159)
val itemPetrifyPotion_4160 = ItemSkillId(4160)
val itemSleepingPotion_4161 = ItemSkillId(4161)
val itemSilencingPotion_4162 = ItemSkillId(4162)
val itemBlindingPotion_4163 = ItemSkillId(4163)
val itemPrismPowder_4164 = ItemSkillId(4164)
val itemSilentOil_4165 = ItemSkillId(4165)
val itemDeodorizer_4166 = ItemSkillId(4166)
val itemCracker_4167 = ItemSkillId(4167)
val itemTwinkleShower_4168 = ItemSkillId(4168)
val itemLittleComet_4169 = ItemSkillId(4169)
val itemWeddingBell_4170 = ItemSkillId(4170)
val itemVitriol_4171 = ItemSkillId(4171)
val itemReraiser_4172 = ItemSkillId(4172)
val itemHiReraiser_4173 = ItemSkillId(4173)
val itemVileElixir_4174 = ItemSkillId(4174)
val itemVileElixir1_4175 = ItemSkillId(4175)
val itemNewYearsGift_4176 = ItemSkillId(4176)
val itemNewYearsGift_4177 = ItemSkillId(4177)
val itemNewYearsGift_4178 = ItemSkillId(4178)
val itemNewYearsGift_4179 = ItemSkillId(4179)
val itemNewYearsGift_4180 = ItemSkillId(4180)
val itemInstantWarp_4181 = ItemSkillId(4181)
val itemInstantReraise_4182 = ItemSkillId(4182)
val itemKonronHassen_4183 = ItemSkillId(4183)
val itemKongouInaho_4184 = ItemSkillId(4184)
val itemMeifuGoma_4185 = ItemSkillId(4185)
val itemAirborne_4186 = ItemSkillId(4186)
val itemBasMinesGlyph_4187 = ItemSkillId(4187)
val itemBasMrkGlyph_4188 = ItemSkillId(4188)
val itemPortBasGlyph_4189 = ItemSkillId(4189)
val itemEastSanGlyph_4190 = ItemSkillId(4190)
val itemWestSanGlyph_4191 = ItemSkillId(4191)
val itemNorthSanGlyph_4192 = ItemSkillId(4192)
val itemWinWatersGlyph_4193 = ItemSkillId(4193)
val itemPortWinGlyph_4194 = ItemSkillId(4194)
val itemWinWoodsGlyph_4195 = ItemSkillId(4195)
val itemRottenQuiver_4196 = ItemSkillId(4196)
val itemRustyBoltCase_4197 = ItemSkillId(4197)
val itemDragonChronicles_4198 = ItemSkillId(4198)
val itemStrengthPotion_4199 = ItemSkillId(4199)
val itemManaBoost_4200 = ItemSkillId(4200)
val itemDexterityPotion_4201 = ItemSkillId(4201)
val itemDaedalusWing_4202 = ItemSkillId(4202)
val itemVitalityPotion_4203 = ItemSkillId(4203)
val itemPetraEater_4204 = ItemSkillId(4204)
val itemAgilityPotion_4205 = ItemSkillId(4205)
val itemCatholicon_4206 = ItemSkillId(4206)
val itemIntPotion_4207 = ItemSkillId(4207)
val itemCatholicon1_4208 = ItemSkillId(4208)
val itemMindPotion_4209 = ItemSkillId(4209)
val itemLetheWater_4210 = ItemSkillId(4210)
val itemCharismaPotion_4211 = ItemSkillId(4211)
val itemLetheWater1_4212 = ItemSkillId(4212)
val itemIcarusWing_4213 = ItemSkillId(4213)
val itemLethePowder_4214 = ItemSkillId(4214)
val itemPopstar_4215 = ItemSkillId(4215)
val itemBrilliantSnow_4216 = ItemSkillId(4216)
val itemSparklingHand_4217 = ItemSkillId(4217)
val itemAirRider_4218 = ItemSkillId(4218)
val itemStoneQuiver_4219 = ItemSkillId(4219)
val itemBoneQuiver_4220 = ItemSkillId(4220)
val itemBeetleQuiver_4221 = ItemSkillId(4221)
val itemHornQuiver_4222 = ItemSkillId(4222)
val itemScorpionQuiver_4223 = ItemSkillId(4223)
val itemDemonQuiver_4224 = ItemSkillId(4224)
val itemIronQuiver_4225 = ItemSkillId(4225)
val itemSilverQuiver_4226 = ItemSkillId(4226)
val itemBBoltQuiver_4227 = ItemSkillId(4227)
val itemMBoltQuiver_4228 = ItemSkillId(4228)
val itemDBoltQuiver_4229 = ItemSkillId(4229)
val itemNewYearsGift_4230 = ItemSkillId(4230)
val itemNewYearsGift_4231 = ItemSkillId(4231)
val itemNewYearsGift_4232 = ItemSkillId(4232)
val itemNewYearsGift_4233 = ItemSkillId(4233)
val itemCursedBeverage_4234 = ItemSkillId(4234)
val itemCursedSoup_4235 = ItemSkillId(4235)
val itemTimelessHrglass_4236 = ItemSkillId(4236)
val itemPerpetualHrglass_4237 = ItemSkillId(4237)
val itemInfernoCrystal_4238 = ItemSkillId(4238)
val itemGlacierCrystal_4239 = ItemSkillId(4239)
val itemCycloneCrystal_4240 = ItemSkillId(4240)
val itemTerraCrystal_4241 = ItemSkillId(4241)
val itemPlasmaCrystal_4242 = ItemSkillId(4242)
val itemTorrentCrystal_4243 = ItemSkillId(4243)
val itemAuroraCrystal_4244 = ItemSkillId(4244)
val itemTwilightCrystal_4245 = ItemSkillId(4245)
val itemCantarella_4246 = ItemSkillId(4246)
val itemMiratetesMem_4247 = ItemSkillId(4247)
val itemGinuvasTheory_4248 = ItemSkillId(4248)
val itemSStratagems_4249 = ItemSkillId(4249)
val itemCrackler_4250 = ItemSkillId(4250)
val itemFestiveFan_4251 = ItemSkillId(4251)
val itemSummerFan_4252 = ItemSkillId(4252)
val itemSpiritMasque_4253 = ItemSkillId(4253)
val itemMegalixir_4254 = ItemSkillId(4254)
val itemManaPowder_4255 = ItemSkillId(4255)
val itemOukaRanman_4256 = ItemSkillId(4256)
val itemPapillion_4257 = ItemSkillId(4257)
val itemRedDrop_4258 = ItemSkillId(4258)
val itemClearDrop_4259 = ItemSkillId(4259)
val itemGreenDrop_4260 = ItemSkillId(4260)
val itemYellowDrop_4261 = ItemSkillId(4261)
val itemPurpleDrop_4262 = ItemSkillId(4262)
val itemBlueDrop_4263 = ItemSkillId(4263)
val itemWhiteDrop_4264 = ItemSkillId(4264)
val itemBlackDrop_4265 = ItemSkillId(4265)
val itemFulmlongSub_4266 = ItemSkillId(4266)
val itemBtrNebimonite_4267 = ItemSkillId(4267)
val itemSeaSprayRisotto_4268 = ItemSkillId(4268)
val itemBijouGlace_4269 = ItemSkillId(4269)
val itemSwtRiceCake_4270 = ItemSkillId(4270)
val itemRiceDumpling_4271 = ItemSkillId(4271)
val itemDragonMeat_4272 = ItemSkillId(4272)
val itemKitron_4273 = ItemSkillId(4273)
val itemPersikos_4274 = ItemSkillId(4274)
val itemEmperorRoe_4275 = ItemSkillId(4275)
val itemFlintCaviar_4276 = ItemSkillId(4276)
val itemTonosamaRBall_4277 = ItemSkillId(4277)
val itemShogunRBall_4278 = ItemSkillId(4278)
val itemTavnazianSalad_4279 = ItemSkillId(4279)
val itemGCracker1_4280 = ItemSkillId(4280)
val itemRedHotCracker_4281 = ItemSkillId(4281)
val itemPipinPopoto_4282 = ItemSkillId(4282)
val itemChocodelight_4283 = ItemSkillId(4283)
val itemTenderNavarin_4284 = ItemSkillId(4284)
val itemOceanSoup_4285 = ItemSkillId(4285)
val itemHealingTea_4286 = ItemSkillId(4286)
val itemOpoopoTart_4287 = ItemSkillId(4287)
val itemZebraEel_4288 = ItemSkillId(4288)
val itemForestCarp_4289 = ItemSkillId(4289)
val itemElshimoFrog_4290 = ItemSkillId(4290)
val itemSandfish_4291 = ItemSkillId(4291)
val itemPaindeNeige_4292 = ItemSkillId(4292)
val itemMonasticSaute_4293 = ItemSkillId(4293)
val itemMedicinalQuus_4294 = ItemSkillId(4294)
val itemRoyalSaute_4295 = ItemSkillId(4295)
val itemGreenCurry_4296 = ItemSkillId(4296)
val itemBlackCurry_4297 = ItemSkillId(4297)
val itemRedCurry_4298 = ItemSkillId(4298)
val itemOrangeauLait_4299 = ItemSkillId(4299)
val itemAppleauLait_4300 = ItemSkillId(4300)
val itemPearauLait_4301 = ItemSkillId(4301)
val itemPamamaauLait_4302 = ItemSkillId(4302)
val itemPersikosauLait_4303 = ItemSkillId(4303)
val itemGrimmonite_4304 = ItemSkillId(4304)
val itemRyuguTitan_4305 = ItemSkillId(4305)
val itemGiantDonko_4306 = ItemSkillId(4306)
val itemJungleCatfish_4307 = ItemSkillId(4307)
val itemGiantChirai_4308 = ItemSkillId(4308)
val itemCaveCherax_4309 = ItemSkillId(4309)
val itemTinyGoldfish_4310 = ItemSkillId(4310)
val itemBlkBubbleEye_4311 = ItemSkillId(4311)
val itemLionhead_4312 = ItemSkillId(4312)
val itemBlindfish_4313 = ItemSkillId(4313)
val itemBibikibo_4314 = ItemSkillId(4314)
val itemLungfish_4315 = ItemSkillId(4315)
val itemArmoredPisces_4316 = ItemSkillId(4316)
val itemTrilobite_4317 = ItemSkillId(4317)
val itemBibikiUrchin_4318 = ItemSkillId(4318)
val itemTricorn_4319 = ItemSkillId(4319)
val itemApplePie1_4320 = ItemSkillId(4320)
val itemTTimbersSalad_4321 = ItemSkillId(4321)
val itemDhalmelPie1_4322 = ItemSkillId(4322)
val itemVegetableBroth_4323 = ItemSkillId(4323)
val itemHobChocolate_4324 = ItemSkillId(4324)
val itemHobgoblinPie_4325 = ItemSkillId(4325)
val itemFrogFlambe_4326 = ItemSkillId(4326)
val itemEmeraldSoup_4327 = ItemSkillId(4327)
val itemHobgoblinBread_4328 = ItemSkillId(4328)
val itemNewtFlambe_4329 = ItemSkillId(4329)
val itemWitchRisotto_4330 = ItemSkillId(4330)
val itemImperialOmelette_4331 = ItemSkillId(4331)
val itemOrangeKuchen1_4332 = ItemSkillId(4332)
val itemWitchSoup_4333 = ItemSkillId(4333)
val itemGrilledCorn_4334 = ItemSkillId(4334)
val itemJuicyMutton_4335 = ItemSkillId(4335)
val itemSwtBkdApple_4336 = ItemSkillId(4336)
val itemStaminaSoup_4337 = ItemSkillId(4337)
val itemStmdCrayfish_4338 = ItemSkillId(4338)
val itemRolanPie1_4339 = ItemSkillId(4339)
val itemOpticalSoup_4340 = ItemSkillId(4340)
val itemSunsetSoup_4341 = ItemSkillId(4341)
val itemSteamedCrab_4342 = ItemSkillId(4342)
val itemWitchKabob_4343 = ItemSkillId(4343)
val itemWitchStew_4344 = ItemSkillId(4344)
val itemFlndMeuniere1_4345 = ItemSkillId(4345)
val itemBassMeuniere1_4346 = ItemSkillId(4346)
val itemSlmnMeuniere1_4347 = ItemSkillId(4347)
val itemMttnEnchilada_4348 = ItemSkillId(4348)
val itemBunnyBall_4349 = ItemSkillId(4349)
val itemDragonSteak_4350 = ItemSkillId(4350)
val itemGiddeusWater_4351 = ItemSkillId(4351)
val itemDerflandPear_4352 = ItemSkillId(4352)
val itemSeaBassCroute_4353 = ItemSkillId(4353)
val itemShiningTrout_4354 = ItemSkillId(4354)
val itemSalmonSub_4355 = ItemSkillId(4355)
val itemWhiteBread_4356 = ItemSkillId(4356)
val itemCrawlerEgg_4357 = ItemSkillId(4357)
val itemHareMeat_4358 = ItemSkillId(4358)
val itemDhalmelMeat_4359 = ItemSkillId(4359)
val itemBastoreSardine_4360 = ItemSkillId(4360)
val itemNebimonite_4361 = ItemSkillId(4361)
val itemLizardEgg_4362 = ItemSkillId(4362)
val itemFaerieApple_4363 = ItemSkillId(4363)
val itemBlackBread_4364 = ItemSkillId(4364)
val itemRolanberry_4365 = ItemSkillId(4365)
val itemLaTheineCbg_4366 = ItemSkillId(4366)
val itemBatagreens_4367 = ItemSkillId(4367)
val item2LeafMandraBud_4368 = ItemSkillId(4368)
val item4LeafMandraBud_4369 = ItemSkillId(4369)
val itemHoney_4370 = ItemSkillId(4370)
val itemGrilledHare_4371 = ItemSkillId(4371)
val itemGSheepMeat_4372 = ItemSkillId(4372)
val itemWoozyshroom_4373 = ItemSkillId(4373)
val itemSleepshroom_4374 = ItemSkillId(4374)
val itemDanceshroom_4375 = ItemSkillId(4375)
val itemMeatJerky_4376 = ItemSkillId(4376)
val itemCoeurlMeat_4377 = ItemSkillId(4377)
val itemSelbinaMilk_4378 = ItemSkillId(4378)
val itemChevalSalmon_4379 = ItemSkillId(4379)
val itemSmokedSalmon_4380 = ItemSkillId(4380)
val itemMeatMithkabob_4381 = ItemSkillId(4381)
val itemFrostTurnip_4382 = ItemSkillId(4382)
val itemGoldLobster_4383 = ItemSkillId(4383)
val itemBlackSole_4384 = ItemSkillId(4384)
val itemZafmlugBass_4385 = ItemSkillId(4385)
val itemKingTruffle_4386 = ItemSkillId(4386)
val itemWildOnion_4387 = ItemSkillId(4387)
val itemEggplant_4388 = ItemSkillId(4388)
val itemSandOrCarrot_4389 = ItemSkillId(4389)
val itemMithranTomato_4390 = ItemSkillId(4390)
val itemBretzel_4391 = ItemSkillId(4391)
val itemSarutaOrange_4392 = ItemSkillId(4392)
val itemOrangeKuchen_4393 = ItemSkillId(4393)
val itemGingerCookie_4394 = ItemSkillId(4394)
val itemGalkanSausage_4395 = ItemSkillId(4395)
val itemSausageRoll_4396 = ItemSkillId(4396)
val itemCinnacookie_4397 = ItemSkillId(4397)
val itemFishMithkabob_4398 = ItemSkillId(4398)
val itemBluetail_4399 = ItemSkillId(4399)
val itemLandCrabMeat_4400 = ItemSkillId(4400)
val itemMoatCarp_4401 = ItemSkillId(4401)
val itemRedTerrapin_4402 = ItemSkillId(4402)
val itemYellowGlobe_4403 = ItemSkillId(4403)
val itemRoastTrout_4404 = ItemSkillId(4404)
val itemRiceBall_4405 = ItemSkillId(4405)
val itemBakedApple_4406 = ItemSkillId(4406)
val itemCarpSushi_4407 = ItemSkillId(4407)
val itemTortilla_4408 = ItemSkillId(4408)
val itemHardboiledEgg_4409 = ItemSkillId(4409)
val itemRoastMushroom_4410 = ItemSkillId(4410)
val itemDhalmelPie_4411 = ItemSkillId(4411)
val itemThundermelon_4412 = ItemSkillId(4412)
val itemApplePie_4413 = ItemSkillId(4413)
val itemRolanberryPie_4414 = ItemSkillId(4414)
val itemRoastedCorn_4415 = ItemSkillId(4415)
val itemPeaSoup_4416 = ItemSkillId(4416)
val itemEggSoup_4417 = ItemSkillId(4417)
val itemTurtleSoup_4418 = ItemSkillId(4418)
val itemMushroomSoup_4419 = ItemSkillId(4419)
val itemTomatoSoup_4420 = ItemSkillId(4420)
val itemMelonPie_4421 = ItemSkillId(4421)
val itemOrangeJuice_4422 = ItemSkillId(4422)
val itemAppleJuice_4423 = ItemSkillId(4423)
val itemMelonJuice_4424 = ItemSkillId(4424)
val itemTomatoJuice_4425 = ItemSkillId(4425)
val itemTricoloredCarp_4426 = ItemSkillId(4426)
val itemGoldCarp_4427 = ItemSkillId(4427)
val itemDarkBass_4428 = ItemSkillId(4428)
val itemBlackEel_4429 = ItemSkillId(4429)
val itemPumpkinSoup_4430 = ItemSkillId(4430)
val itemSandOrGrape_4431 = ItemSkillId(4431)
val itemKazhamPineapl_4432 = ItemSkillId(4432)
val itemDhalmelStew_4433 = ItemSkillId(4433)
val itemMushroomRisotto_4434 = ItemSkillId(4434)
val itemCockatriceMeat_4435 = ItemSkillId(4435)
val itemBakedPopoto_4436 = ItemSkillId(4436)
val itemRoastMutton_4437 = ItemSkillId(4437)
val itemDhalmelSteak_4438 = ItemSkillId(4438)
val itemNavarin_4439 = ItemSkillId(4439)
val itemWhitefishStew_4440 = ItemSkillId(4440)
val itemGrapeJuice_4441 = ItemSkillId(4441)
val itemPineappleJuice_4442 = ItemSkillId(4442)
val itemCobaltJellyfish_4443 = ItemSkillId(4443)
val itemRarabTail_4444 = ItemSkillId(4444)
val itemYagudoCherry_4445 = ItemSkillId(4445)
val itemPumpkinPie_4446 = ItemSkillId(4446)
val itemScreamFungus_4447 = ItemSkillId(4447)
val itemPuffball_4448 = ItemSkillId(4448)
val itemReishiMushroom_4449 = ItemSkillId(4449)
val itemCoralFungus_4450 = ItemSkillId(4450)
val itemSilverShark_4451 = ItemSkillId(4451)
val itemSharkFinSoup_4452 = ItemSkillId(4452)
val itemEyeballSoup_4453 = ItemSkillId(4453)
val itemEmperorFish_4454 = ItemSkillId(4454)
val itemPebbleSoup_4455 = ItemSkillId(4455)
val itemBoiledCrab_4456 = ItemSkillId(4456)
val itemEelKabob_4457 = ItemSkillId(4457)
val itemGoblinBread_4458 = ItemSkillId(4458)
val itemNebimoniteBake_4459 = ItemSkillId(4459)
val itemStoneCheese_4460 = ItemSkillId(4460)
val itemBastoreBream_4461 = ItemSkillId(4461)
val itemMonkeOnke_4462 = ItemSkillId(4462)
val itemTakitaro_4463 = ItemSkillId(4463)
val itemPipira_4464 = ItemSkillId(4464)
val itemGoblinStew_4465 = ItemSkillId(4465)
val itemSpicyCracker_4466 = ItemSkillId(4466)
val itemGarlicCracker_4467 = ItemSkillId(4467)
val itemPamamas_4468 = ItemSkillId(4468)
val itemGiantCatfish_4469 = ItemSkillId(4469)
val itemIcefish_4470 = ItemSkillId(4470)
val itemBladefish_4471 = ItemSkillId(4471)
val itemCrayfish_4472 = ItemSkillId(4472)
val itemCrescentFish_4473 = ItemSkillId(4473)
val itemGigantSquid_4474 = ItemSkillId(4474)
val itemSeaZombie_4475 = ItemSkillId(4475)
val itemTitanictus_4476 = ItemSkillId(4476)
val itemGavialFish_4477 = ItemSkillId(4477)
val itemThreeeyedFish_4478 = ItemSkillId(4478)
val itemBhefhelMarlin_4479 = ItemSkillId(4479)
val itemGugruTuna_4480 = ItemSkillId(4480)
val itemOgreEel_4481 = ItemSkillId(4481)
val itemNosteauHerring_4482 = ItemSkillId(4482)
val itemTigerCod_4483 = ItemSkillId(4483)
val itemShallShell_4484 = ItemSkillId(4484)
val itemNobleLady_4485 = ItemSkillId(4485)
val itemDragonHeart_4486 = ItemSkillId(4486)
val itemColoredEgg_4487 = ItemSkillId(4487)
val itemJackoLantern_4488 = ItemSkillId(4488)
val itemVegetableGruel_4489 = ItemSkillId(4489)
val itemPickledHerring_4490 = ItemSkillId(4490)
val itemWatermelon_4491 = ItemSkillId(4491)
val itemPuls_4492 = ItemSkillId(4492)
val itemWindurstianTea_4493 = ItemSkillId(4493)
val itemSandOrianTea_4494 = ItemSkillId(4494)
val itemGobChocolate_4495 = ItemSkillId(4495)
val itemBblChocolate_4496 = ItemSkillId(4496)
val itemHeartChocolate_4497 = ItemSkillId(4497)
val itemChocomilk_4498 = ItemSkillId(4498)
val itemIronBread_4499 = ItemSkillId(4499)
val itemGreedie_4500 = ItemSkillId(4500)
val itemFatGreedie_4501 = ItemSkillId(4501)
val itemMarronGlace_4502 = ItemSkillId(4502)
val itemBuburimuGrape_4503 = ItemSkillId(4503)
val itemAcorn_4504 = ItemSkillId(4504)
val itemSunflowerSeeds_4505 = ItemSkillId(4505)
val itemMuttonTortilla_4506 = ItemSkillId(4506)
val itemRarabMeatball_4507 = ItemSkillId(4507)
val itemRoyalJelly_4508 = ItemSkillId(4508)
val itemDistilledWater_4509 = ItemSkillId(4509)
val itemAcornCookie_4510 = ItemSkillId(4510)
val itemAmbrosia_4511 = ItemSkillId(4511)
val itemVampireJuice_4512 = ItemSkillId(4512)
val itemAmrita_4513 = ItemSkillId(4513)
val itemQuus_4514 = ItemSkillId(4514)
val itemCopperFrog_4515 = ItemSkillId(4515)
val itemGrilledBlackHare_4516 = ItemSkillId(4516)
val itemYellowCurry_4517 = ItemSkillId(4517)
val itemSheepJerky_4518 = ItemSkillId(4518)
val itemWildSteak_4519 = ItemSkillId(4519)
val itemCoinCookie_4520 = ItemSkillId(4520)
val itemHumptySoup_4521 = ItemSkillId(4521)
val itemJackoSoup_4522 = ItemSkillId(4522)
val itemMelonPie1_4523 = ItemSkillId(4523)
val itemRoyalTea_4524 = ItemSkillId(4524)
val itemPumpkinPie1_4525 = ItemSkillId(4525)
val itemSilkwormEgg_4526 = ItemSkillId(4526)
val itemMarysMilk_4527 = ItemSkillId(4527)
val itemCrystalBass_4528 = ItemSkillId(4528)
val itemRolanberry881_4529 = ItemSkillId(4529)
val itemRolanberry874_4530 = ItemSkillId(4530)
val itemRolanberry864_4531 = ItemSkillId(4531)
val itemSoftboiledEgg_4532 = ItemSkillId(4532)
val itemDeliciousPuls_4533 = ItemSkillId(4533)
val itemMedicinalGruel_4534 = ItemSkillId(4534)
val itemBoiledCrayfish_4535 = ItemSkillId(4535)
val itemBlackenedFrog_4536 = ItemSkillId(4536)
val itemRoastCarp_4537 = ItemSkillId(4537)
val itemRoastPipira_4538 = ItemSkillId(4538)
val itemGoblinPie_4539 = ItemSkillId(4539)
val itemBoiledTunaHead_4540 = ItemSkillId(4540)
val itemGoblinDrink_4541 = ItemSkillId(4541)
val itemBrainStew_4542 = ItemSkillId(4542)
val itemGoblinMushpot_4543 = ItemSkillId(4543)
val itemMushroomStew_4544 = ItemSkillId(4544)
val itemGysahlGreens_4545 = ItemSkillId(4545)
val itemRaisinBread_4546 = ItemSkillId(4546)
val itemBoiledCockatrice_4547 = ItemSkillId(4547)
val itemCoeurlSaute_4548 = ItemSkillId(4548)
val itemDragonSoup_4549 = ItemSkillId(4549)
val itemBreamRisotto_4550 = ItemSkillId(4550)
val itemSalmonCroute_4551 = ItemSkillId(4551)
val itemHerbCrawlerEggs_4552 = ItemSkillId(4552)
val itemBatagreenSaute_4553 = ItemSkillId(4553)
val itemShallopsTropicale_4554 = ItemSkillId(4554)
val itemWindurstSalad_4555 = ItemSkillId(4555)
val itemIcecapRolanberry_4556 = ItemSkillId(4556)
val itemSteamedCatfish_4557 = ItemSkillId(4557)
val itemYagudoDrink_4558 = ItemSkillId(4558)
val itemHerbQuus_4559 = ItemSkillId(4559)
val itemVegetableSoup_4560 = ItemSkillId(4560)
val itemSeafoodStew_4561 = ItemSkillId(4561)
val itemOdontotyrannus_4562 = ItemSkillId(4562)
val itemPamamaTart_4563 = ItemSkillId(4563)
val itemRoyalOmelette_4564 = ItemSkillId(4564)
val itemSobbingFungus_4565 = ItemSkillId(4565)
val itemDeathball_4566 = ItemSkillId(4566)
val itemMoonCarrot_4567 = ItemSkillId(4567)
val itemMoonBall_4568 = ItemSkillId(4568)
val itemQuadavStew_4569 = ItemSkillId(4569)
val itemBirdEgg_4570 = ItemSkillId(4570)
val itemBeaugreens_4571 = ItemSkillId(4571)
val itemBeaugrSaute_4572 = ItemSkillId(4572)
val itemSteelBread_4573 = ItemSkillId(4573)
val itemMeatChiefkabob_4574 = ItemSkillId(4574)
val itemFishChiefkabob_4575 = ItemSkillId(4575)
val itemWizardCookie_4576 = ItemSkillId(4576)
val itemWildCookie_4577 = ItemSkillId(4577)
val itemSausage_4578 = ItemSkillId(4578)
val itemElshimoNewt_4579 = ItemSkillId(4579)
val itemCoralButterfly_4580 = ItemSkillId(4580)
val itemBlackenedNewt_4581 = ItemSkillId(4581)
val itemBassMeuniere_4582 = ItemSkillId(4582)
val itemSalmonMeuniere_4583 = ItemSkillId(4583)
val itemFlounderMeuniere_4584 = ItemSkillId(4584)
val itemBroiledPipira_4585 = ItemSkillId(4585)
val itemBroiledCarp_4586 = ItemSkillId(4586)
val itemBroiledTrout_4587 = ItemSkillId(4587)
val itemBroiledEel_4588 = ItemSkillId(4588)
val itemWildStew_4589 = ItemSkillId(4589)
val itemSalmonRiceBall_4590 = ItemSkillId(4590)
val itemPumpernickel_4591 = ItemSkillId(4591)
val itemWisdomSoup_4592 = ItemSkillId(4592)
val itemRockCheese_4593 = ItemSkillId(4593)
val itemSnowyRolanberry_4594 = ItemSkillId(4594)
val itemPartyEgg_4595 = ItemSkillId(4595)
val itemWildPamamas_4596 = ItemSkillId(4596)
val itemWildMelon_4597 = ItemSkillId(4597)
val itemWildPineapple_4598 = ItemSkillId(4598)
val itemBlackenedToad_4599 = ItemSkillId(4599)
val itemLuckyEgg_4600 = ItemSkillId(4600)
val itemSopaPezBlanco_4601 = ItemSkillId(4601)
val itemWarmEgg_4602 = ItemSkillId(4602)
val itemChamomileTea_4603 = ItemSkillId(4603)
val itemRogueRiceBall_4604 = ItemSkillId(4604)
val itemNavalRiceBall_4605 = ItemSkillId(4605)
val itemDia_4606 = ItemSkillId(4606)
val itemStone_4607 = ItemSkillId(4607)
val itemCure_4608 = ItemSkillId(4608)
val itemCure_4609 = ItemSkillId(4609)
val itemCureII_4610 = ItemSkillId(4610)
val itemCureIII_4611 = ItemSkillId(4611)
val itemCureIV_4612 = ItemSkillId(4612)
val itemCureV_4613 = ItemSkillId(4613)
val itemCureVI_4614 = ItemSkillId(4614)
val itemCuraga_4615 = ItemSkillId(4615)
val itemCuragaII_4616 = ItemSkillId(4616)
val itemCuragaIII_4617 = ItemSkillId(4617)
val itemCuragaIV_4618 = ItemSkillId(4618)
val itemCuragaV_4619 = ItemSkillId(4619)
val itemRaise_4620 = ItemSkillId(4620)
val itemRaiseII_4621 = ItemSkillId(4621)
val itemPoisona_4622 = ItemSkillId(4622)
val itemParalyna_4623 = ItemSkillId(4623)
val itemBlindna_4624 = ItemSkillId(4624)
val itemSilena_4625 = ItemSkillId(4625)
val itemStona_4626 = ItemSkillId(4626)
val itemViruna_4627 = ItemSkillId(4627)
val itemCursna_4628 = ItemSkillId(4628)
val itemHoly_4629 = ItemSkillId(4629)
val itemHolyII_4630 = ItemSkillId(4630)
val itemDia_4631 = ItemSkillId(4631)
val itemDiaII_4632 = ItemSkillId(4632)
val itemDiaIII_4633 = ItemSkillId(4633)
val itemBanish_4636 = ItemSkillId(4636)
val itemBanishII_4637 = ItemSkillId(4637)
val itemBanishIII_4638 = ItemSkillId(4638)
val itemDiaga_4641 = ItemSkillId(4641)
val itemBanishga_4646 = ItemSkillId(4646)
val itemBanishgaII_4647 = ItemSkillId(4647)
val itemProtect_4651 = ItemSkillId(4651)
val itemProtectII_4652 = ItemSkillId(4652)
val itemProtectIII_4653 = ItemSkillId(4653)
val itemProtectIV_4654 = ItemSkillId(4654)
val itemProtectV_4655 = ItemSkillId(4655)
val itemShell_4656 = ItemSkillId(4656)
val itemShellII_4657 = ItemSkillId(4657)
val itemShellIII_4658 = ItemSkillId(4658)
val itemShellIV_4659 = ItemSkillId(4659)
val itemShellV_4660 = ItemSkillId(4660)
val itemBlink_4661 = ItemSkillId(4661)
val itemStoneskin_4662 = ItemSkillId(4662)
val itemAquaveil_4663 = ItemSkillId(4663)
val itemSlow_4664 = ItemSkillId(4664)
val itemHaste_4665 = ItemSkillId(4665)
val itemParalyze_4666 = ItemSkillId(4666)
val itemSilence_4667 = ItemSkillId(4667)
val itemBarfire_4668 = ItemSkillId(4668)
val itemBarblizzard_4669 = ItemSkillId(4669)
val itemBaraero_4670 = ItemSkillId(4670)
val itemBarstone_4671 = ItemSkillId(4671)
val itemBarthunder_4672 = ItemSkillId(4672)
val itemBarwater_4673 = ItemSkillId(4673)
val itemBarfira_4674 = ItemSkillId(4674)
val itemBarblizzara_4675 = ItemSkillId(4675)
val itemBaraera_4676 = ItemSkillId(4676)
val itemBarstonra_4677 = ItemSkillId(4677)
val itemBarthundra_4678 = ItemSkillId(4678)
val itemBarwatera_4679 = ItemSkillId(4679)
val itemBarsleep_4680 = ItemSkillId(4680)
val itemBarpoison_4681 = ItemSkillId(4681)
val itemBarparalyze_4682 = ItemSkillId(4682)
val itemBarblind_4683 = ItemSkillId(4683)
val itemBarsilence_4684 = ItemSkillId(4684)
val itemBarpetrify_4685 = ItemSkillId(4685)
val itemBarvirus_4686 = ItemSkillId(4686)
val itemRecallJugner_4687 = ItemSkillId(4687)
val itemRecallPashh_4688 = ItemSkillId(4688)
val itemRecallMeriph_4689 = ItemSkillId(4689)
val itemBaramnesia_4690 = ItemSkillId(4690)
val itemBaramnesra_4691 = ItemSkillId(4691)
val itemHasteII_4692 = ItemSkillId(4692)
val itemBarsleepra_4694 = ItemSkillId(4694)
val itemBarpoisonra_4695 = ItemSkillId(4695)
val itemBarparalyzra_4696 = ItemSkillId(4696)
val itemBarblindra_4697 = ItemSkillId(4697)
val itemBarsilencera_4698 = ItemSkillId(4698)
val itemBarpetra_4699 = ItemSkillId(4699)
val itemBarvira_4700 = ItemSkillId(4700)
val itemCura_4701 = ItemSkillId(4701)
val itemSacrifice_4702 = ItemSkillId(4702)
val itemEsuna_4703 = ItemSkillId(4703)
val itemAuspice_4704 = ItemSkillId(4704)
val itemTemper_4705 = ItemSkillId(4705)
val itemEnlight_4706 = ItemSkillId(4706)
val itemEndark_4707 = ItemSkillId(4707)
val itemEnfire_4708 = ItemSkillId(4708)
val itemEnblizzard_4709 = ItemSkillId(4709)
val itemEnaero_4710 = ItemSkillId(4710)
val itemEnstone_4711 = ItemSkillId(4711)
val itemEnthunder_4712 = ItemSkillId(4712)
val itemEnwater_4713 = ItemSkillId(4713)
val itemPhalanx_4714 = ItemSkillId(4714)
val itemReprisal_4715 = ItemSkillId(4715)
val itemRegen_4716 = ItemSkillId(4716)
val itemRefresh_4717 = ItemSkillId(4717)
val itemRegenII_4718 = ItemSkillId(4718)
val itemRegenIII_4719 = ItemSkillId(4719)
val itemFlash_4720 = ItemSkillId(4720)
val itemRepose_4721 = ItemSkillId(4721)
val itemEnfireII_4722 = ItemSkillId(4722)
val itemEnblizzardII_4723 = ItemSkillId(4723)
val itemEnaeroII_4724 = ItemSkillId(4724)
val itemEnstoneII_4725 = ItemSkillId(4725)
val itemEnthunderII_4726 = ItemSkillId(4726)
val itemEnwaterII_4727 = ItemSkillId(4727)
val itemTeleportYhoat_4728 = ItemSkillId(4728)
val itemTeleportAltep_4729 = ItemSkillId(4729)
val itemTeleportHolla_4730 = ItemSkillId(4730)
val itemTeleportDem_4731 = ItemSkillId(4731)
val itemTeleportMea_4732 = ItemSkillId(4732)
val itemProtectra_4733 = ItemSkillId(4733)
val itemProtectraII_4734 = ItemSkillId(4734)
val itemProtectraIII_4735 = ItemSkillId(4735)
val itemProtectraIV_4736 = ItemSkillId(4736)
val itemProtectraV_4737 = ItemSkillId(4737)
val itemShellra_4738 = ItemSkillId(4738)
val itemShellraII_4739 = ItemSkillId(4739)
val itemShellraIII_4740 = ItemSkillId(4740)
val itemShellraIV_4741 = ItemSkillId(4741)
val itemShellraV_4742 = ItemSkillId(4742)
val itemReraise_4743 = ItemSkillId(4743)
val itemInvisible_4744 = ItemSkillId(4744)
val itemSneak_4745 = ItemSkillId(4745)
val itemDeodorize_4746 = ItemSkillId(4746)
val itemTeleportVahzl_4747 = ItemSkillId(4747)
val itemRaiseIII_4748 = ItemSkillId(4748)
val itemReraiseII_4749 = ItemSkillId(4749)
val itemReraiseIII_4750 = ItemSkillId(4750)
val itemErase_4751 = ItemSkillId(4751)
val itemFire_4752 = ItemSkillId(4752)
val itemFireII_4753 = ItemSkillId(4753)
val itemFireIII_4754 = ItemSkillId(4754)
val itemFireIV_4755 = ItemSkillId(4755)
val itemFireV_4756 = ItemSkillId(4756)
val itemBlizzard_4757 = ItemSkillId(4757)
val itemBlizzardII_4758 = ItemSkillId(4758)
val itemBlizzardIII_4759 = ItemSkillId(4759)
val itemBlizzardIV_4760 = ItemSkillId(4760)
val itemBlizzardV_4761 = ItemSkillId(4761)
val itemAero_4762 = ItemSkillId(4762)
val itemAeroII_4763 = ItemSkillId(4763)
val itemAeroIII_4764 = ItemSkillId(4764)
val itemAeroIV_4765 = ItemSkillId(4765)
val itemAeroV_4766 = ItemSkillId(4766)
val itemStone_4767 = ItemSkillId(4767)
val itemStoneII_4768 = ItemSkillId(4768)
val itemStoneIII_4769 = ItemSkillId(4769)
val itemStoneIV_4770 = ItemSkillId(4770)
val itemStoneV_4771 = ItemSkillId(4771)
val itemThunder_4772 = ItemSkillId(4772)
val itemThunderII_4773 = ItemSkillId(4773)
val itemThunderIII_4774 = ItemSkillId(4774)
val itemThunderIV_4775 = ItemSkillId(4775)
val itemThunderV_4776 = ItemSkillId(4776)
val itemWater_4777 = ItemSkillId(4777)
val itemWaterII_4778 = ItemSkillId(4778)
val itemWaterIII_4779 = ItemSkillId(4779)
val itemWaterIV_4780 = ItemSkillId(4780)
val itemWaterV_4781 = ItemSkillId(4781)
val itemFiraga_4782 = ItemSkillId(4782)
val itemFiragaII_4783 = ItemSkillId(4783)
val itemFiragaIII_4784 = ItemSkillId(4784)
val itemBlizzaga_4787 = ItemSkillId(4787)
val itemBlizzagaII_4788 = ItemSkillId(4788)
val itemBlizzagaIII_4789 = ItemSkillId(4789)
val itemAeroga_4792 = ItemSkillId(4792)
val itemAerogaII_4793 = ItemSkillId(4793)
val itemAerogaIII_4794 = ItemSkillId(4794)
val itemStonega_4797 = ItemSkillId(4797)
val itemStonegaII_4798 = ItemSkillId(4798)
val itemStonegaIII_4799 = ItemSkillId(4799)
val itemThundaga_4802 = ItemSkillId(4802)
val itemThundagaII_4803 = ItemSkillId(4803)
val itemThundagaIII_4804 = ItemSkillId(4804)
val itemWaterga_4807 = ItemSkillId(4807)
val itemWatergaII_4808 = ItemSkillId(4808)
val itemWatergaIII_4809 = ItemSkillId(4809)
val itemFlare_4812 = ItemSkillId(4812)
val itemFlareII_4813 = ItemSkillId(4813)
val itemFreeze_4814 = ItemSkillId(4814)
val itemFreezeII_4815 = ItemSkillId(4815)
val itemTornado_4816 = ItemSkillId(4816)
val itemTornadoII_4817 = ItemSkillId(4817)
val itemQuake_4818 = ItemSkillId(4818)
val itemQuakeII_4819 = ItemSkillId(4819)
val itemBurst_4820 = ItemSkillId(4820)
val itemBurstII_4821 = ItemSkillId(4821)
val itemFlood_4822 = ItemSkillId(4822)
val itemFloodII_4823 = ItemSkillId(4823)
val itemGravity_4824 = ItemSkillId(4824)
val itemGravityII_4825 = ItemSkillId(4825)
val itemComet_4827 = ItemSkillId(4827)
val itemPoison_4828 = ItemSkillId(4828)
val itemPoisonII_4829 = ItemSkillId(4829)
val itemPoisonga_4833 = ItemSkillId(4833)
val itemPoisongaII_4834 = ItemSkillId(4834)
val itemBio_4838 = ItemSkillId(4838)
val itemBioII_4839 = ItemSkillId(4839)
val itemBioIII_4840 = ItemSkillId(4840)
val itemBurn_4843 = ItemSkillId(4843)
val itemFrost_4844 = ItemSkillId(4844)
val itemChoke_4845 = ItemSkillId(4845)
val itemRasp_4846 = ItemSkillId(4846)
val itemShock_4847 = ItemSkillId(4847)
val itemDrown_4848 = ItemSkillId(4848)
val itemAddle_4849 = ItemSkillId(4849)
val itemRefreshII_4850 = ItemSkillId(4850)
val itemMeteor_4851 = ItemSkillId(4851)
val itemDrain_4853 = ItemSkillId(4853)
val itemDrainII_4854 = ItemSkillId(4854)
val itemAspir_4855 = ItemSkillId(4855)
val itemAspirII_4856 = ItemSkillId(4856)
val itemBlazeSpikes_4857 = ItemSkillId(4857)
val itemIceSpikes_4858 = ItemSkillId(4858)
val itemShockSpikes_4859 = ItemSkillId(4859)
val itemStun_4860 = ItemSkillId(4860)
val itemSleep_4861 = ItemSkillId(4861)
val itemBlind_4862 = ItemSkillId(4862)
val itemBreak_4863 = ItemSkillId(4863)
val itemBind_4866 = ItemSkillId(4866)
val itemSleepII_4867 = ItemSkillId(4867)
val itemDispel_4868 = ItemSkillId(4868)
val itemWarp_4869 = ItemSkillId(4869)
val itemWarpII_4870 = ItemSkillId(4870)
val itemEscape_4871 = ItemSkillId(4871)
val itemTractor_4872 = ItemSkillId(4872)
val itemRetrace_4873 = ItemSkillId(4873)
val itemAbsorbSTR_4874 = ItemSkillId(4874)
val itemAbsorbDEX_4875 = ItemSkillId(4875)
val itemAbsorbVIT_4876 = ItemSkillId(4876)
val itemAbsorbAGI_4877 = ItemSkillId(4877)
val itemAbsorbINT_4878 = ItemSkillId(4878)
val itemAbsorbMND_4879 = ItemSkillId(4879)
val itemAbsorbCHR_4880 = ItemSkillId(4880)
val itemSleepga_4881 = ItemSkillId(4881)
val itemSleepgaII_4882 = ItemSkillId(4882)
val itemAbsorbTP_4883 = ItemSkillId(4883)
val itemBlindII_4884 = ItemSkillId(4884)
val itemDreadSpikes_4885 = ItemSkillId(4885)
val itemAbsorbACC_4886 = ItemSkillId(4886)
val itemAbsorbAttri_4887 = ItemSkillId(4887)
val itemBreakga_4889 = ItemSkillId(4889)
val itemFiraja_4890 = ItemSkillId(4890)
val itemBlizzaja_4891 = ItemSkillId(4891)
val itemAeroja_4892 = ItemSkillId(4892)
val itemStoneja_4893 = ItemSkillId(4893)
val itemThundaja_4894 = ItemSkillId(4894)
val itemWaterja_4895 = ItemSkillId(4895)
val itemFireSpirit_4896 = ItemSkillId(4896)
val itemIceSpirit_4897 = ItemSkillId(4897)
val itemAirSpirit_4898 = ItemSkillId(4898)
val itemEarthSpirit_4899 = ItemSkillId(4899)
val itemThunderSpirit_4900 = ItemSkillId(4900)
val itemWaterSpirit_4901 = ItemSkillId(4901)
val itemLightSpirit_4902 = ItemSkillId(4902)
val itemDarkSpirit_4903 = ItemSkillId(4903)
val itemDistract_4912 = ItemSkillId(4912)
val itemDistractII_4913 = ItemSkillId(4913)
val itemFrazzle_4914 = ItemSkillId(4914)
val itemFrazzleII_4915 = ItemSkillId(4915)
val itemFira_4916 = ItemSkillId(4916)
val itemFiraII_4917 = ItemSkillId(4917)
val itemBlizzara_4918 = ItemSkillId(4918)
val itemBlizzaraII_4919 = ItemSkillId(4919)
val itemAera_4920 = ItemSkillId(4920)
val itemAeraII_4921 = ItemSkillId(4921)
val itemStonera_4922 = ItemSkillId(4922)
val itemStoneraII_4923 = ItemSkillId(4923)
val itemThundara_4924 = ItemSkillId(4924)
val itemThundaraII_4925 = ItemSkillId(4925)
val itemWatera_4926 = ItemSkillId(4926)
val itemWateraII_4927 = ItemSkillId(4927)
val itemKatonIchi_4928 = ItemSkillId(4928)
val itemKatonNi_4929 = ItemSkillId(4929)
val itemKatonSan_4930 = ItemSkillId(4930)
val itemHyotonIchi_4931 = ItemSkillId(4931)
val itemHyotonNi_4932 = ItemSkillId(4932)
val itemHyotonSan_4933 = ItemSkillId(4933)
val itemHutonIchi_4934 = ItemSkillId(4934)
val itemHutonNi_4935 = ItemSkillId(4935)
val itemHutonSan_4936 = ItemSkillId(4936)
val itemDotonIchi_4937 = ItemSkillId(4937)
val itemDotonNi_4938 = ItemSkillId(4938)
val itemDotonSan_4939 = ItemSkillId(4939)
val itemRaitonIchi_4940 = ItemSkillId(4940)
val itemRaitonNi_4941 = ItemSkillId(4941)
val itemRaitonSan_4942 = ItemSkillId(4942)
val itemSuitonIchi_4943 = ItemSkillId(4943)
val itemSuitonNi_4944 = ItemSkillId(4944)
val itemSuitonSan_4945 = ItemSkillId(4945)
val itemUtsusemiIchi_4946 = ItemSkillId(4946)
val itemUtsusemiNi_4947 = ItemSkillId(4947)
val itemJubakuIchi_4949 = ItemSkillId(4949)
val itemHojoIchi_4952 = ItemSkillId(4952)
val itemHojoNi_4953 = ItemSkillId(4953)
val itemKurayamiIchi_4955 = ItemSkillId(4955)
val itemKurayamiNi_4956 = ItemSkillId(4956)
val itemDokumoriIchi_4958 = ItemSkillId(4958)
val itemTonkoIchi_4961 = ItemSkillId(4961)
val itemTonkoNi_4962 = ItemSkillId(4962)
val itemMonomiIchi_4964 = ItemSkillId(4964)
val itemAishaIchi_4965 = ItemSkillId(4965)
val itemMyoshuIchi_4966 = ItemSkillId(4966)
val itemYurinIchi_4967 = ItemSkillId(4967)
val itemKakkaIchi_4968 = ItemSkillId(4968)
val itemMigawariIchi_4969 = ItemSkillId(4969)
val itemGekkaIchi_4970 = ItemSkillId(4970)
val itemYainIchi_4971 = ItemSkillId(4971)
val itemFoeRequiem_4976 = ItemSkillId(4976)
val itemFoeRequiemII_4977 = ItemSkillId(4977)
val itemFoeRequiemIII_4978 = ItemSkillId(4978)
val itemFoeRequiemIV_4979 = ItemSkillId(4979)
val itemFoeRequiemV_4980 = ItemSkillId(4980)
val itemFoeRequiemVI_4981 = ItemSkillId(4981)
val itemFoeRequiemVII_4982 = ItemSkillId(4982)
val itemHordeLullaby_4984 = ItemSkillId(4984)
val itemHordeLullabyII_4985 = ItemSkillId(4985)
val itemArmysPaeon_4986 = ItemSkillId(4986)
val itemArmysPaeonII_4987 = ItemSkillId(4987)
val itemArmysPaeonIII_4988 = ItemSkillId(4988)
val itemArmysPaeonIV_4989 = ItemSkillId(4989)
val itemArmysPaeonV_4990 = ItemSkillId(4990)
val itemArmysPaeonVI_4991 = ItemSkillId(4991)
val itemMagesBallad_4994 = ItemSkillId(4994)
val itemMagesBalladII_4995 = ItemSkillId(4995)
val itemMagesBalladIII_4996 = ItemSkillId(4996)
val itemKnightsMinne_4997 = ItemSkillId(4997)
val itemKnightsMinneII_4998 = ItemSkillId(4998)
val itemKnightsMinneIII_4999 = ItemSkillId(4999)
val itemKnightsMinneIV_5000 = ItemSkillId(5000)
val itemKnightsMinneV_5001 = ItemSkillId(5001)
val itemValorMinuet_5002 = ItemSkillId(5002)
val itemValorMinuetII_5003 = ItemSkillId(5003)
val itemValorMinuetIII_5004 = ItemSkillId(5004)
val itemValorMinuetIV_5005 = ItemSkillId(5005)
val itemValorMinuetV_5006 = ItemSkillId(5006)
val itemSwordMadrigal_5007 = ItemSkillId(5007)
val itemBladeMadrigal_5008 = ItemSkillId(5008)
val itemHuntersPrelude_5009 = ItemSkillId(5009)
val itemArchersPrelude_5010 = ItemSkillId(5010)
val itemSheepfoeMambo_5011 = ItemSkillId(5011)
val itemDragonfoeMambo_5012 = ItemSkillId(5012)
val itemFowlAubade_5013 = ItemSkillId(5013)
val itemHerbPastoral_5014 = ItemSkillId(5014)
val itemShiningFantasia_5016 = ItemSkillId(5016)
val itemScopsOperetta_5017 = ItemSkillId(5017)
val itemPuppetsOperetta_5018 = ItemSkillId(5018)
val itemGoldCapriccio_5020 = ItemSkillId(5020)
val itemWardingRound_5022 = ItemSkillId(5022)
val itemGoblinGavotte_5023 = ItemSkillId(5023)
val itemAdvancingMarch_5027 = ItemSkillId(5027)
val itemVictoryMarch_5028 = ItemSkillId(5028)
val itemBattlefieldElegy_5029 = ItemSkillId(5029)
val itemCarnageElegy_5030 = ItemSkillId(5030)
val itemSinewyEtude_5032 = ItemSkillId(5032)
val itemDextrousEtude_5033 = ItemSkillId(5033)
val itemVivaciousEtude_5034 = ItemSkillId(5034)
val itemQuickEtude_5035 = ItemSkillId(5035)
val itemLearnedEtude_5036 = ItemSkillId(5036)
val itemSpiritedEtude_5037 = ItemSkillId(5037)
val itemEnchantingEtude_5038 = ItemSkillId(5038)
val itemHerculeanEtude_5039 = ItemSkillId(5039)
val itemUncannyEtude_5040 = ItemSkillId(5040)
val itemVitalEtude_5041 = ItemSkillId(5041)
val itemSwiftEtude_5042 = ItemSkillId(5042)
val itemSageEtude_5043 = ItemSkillId(5043)
val itemLogicalEtude_5044 = ItemSkillId(5044)
val itemBewitchingEtude_5045 = ItemSkillId(5045)
val itemFireCarol_5046 = ItemSkillId(5046)
val itemIceCarol_5047 = ItemSkillId(5047)
val itemWindCarol_5048 = ItemSkillId(5048)
val itemEarthCarol_5049 = ItemSkillId(5049)
val itemLightningCarol_5050 = ItemSkillId(5050)
val itemWaterCarol_5051 = ItemSkillId(5051)
val itemLightCarol_5052 = ItemSkillId(5052)
val itemDarkCarol_5053 = ItemSkillId(5053)
val itemFireCarolII_5054 = ItemSkillId(5054)
val itemIceCarolII_5055 = ItemSkillId(5055)
val itemWindCarolII_5056 = ItemSkillId(5056)
val itemEarthCarolII_5057 = ItemSkillId(5057)
val itemLightningCarolII_5058 = ItemSkillId(5058)
val itemWaterCarolII_5059 = ItemSkillId(5059)
val itemLightCarolII_5060 = ItemSkillId(5060)
val itemDarkCarolII_5061 = ItemSkillId(5061)
val itemFireThrenody_5062 = ItemSkillId(5062)
val itemIceThrenody_5063 = ItemSkillId(5063)
val itemWindThrenody_5064 = ItemSkillId(5064)
val itemEarthThrenody_5065 = ItemSkillId(5065)
val itemLtngThrenody_5066 = ItemSkillId(5066)
val itemWaterThrenody_5067 = ItemSkillId(5067)
val itemLightThrenody_5068 = ItemSkillId(5068)
val itemDarkThrenody_5069 = ItemSkillId(5069)
val itemMagicFinale_5070 = ItemSkillId(5070)
val itemFoeLullaby_5071 = ItemSkillId(5071)
val itemGoddesssHymnus_5072 = ItemSkillId(5072)
val itemChocoboMazurka_5073 = ItemSkillId(5073)
val itemMaidensVirelai_5074 = ItemSkillId(5074)
val itemRaptorMazurka_5075 = ItemSkillId(5075)
val itemFoeSirvente_5076 = ItemSkillId(5076)
val itemAdventurersDirge_5077 = ItemSkillId(5077)
val itemSentinelsScherzo_5078 = ItemSkillId(5078)
val itemFoeLullabyII_5079 = ItemSkillId(5079)
val itemPiningNocturne_5080 = ItemSkillId(5080)
val itemCuraII_5082 = ItemSkillId(5082)
val itemCuraIII_5083 = ItemSkillId(5083)
val itemRegenIV_5085 = ItemSkillId(5085)
val itemRegenV_5086 = ItemSkillId(5086)
val itemGainSTR_5087 = ItemSkillId(5087)
val itemGainDEX_5088 = ItemSkillId(5088)
val itemGainVIT_5089 = ItemSkillId(5089)
val itemGainAGI_5090 = ItemSkillId(5090)
val itemGainINT_5091 = ItemSkillId(5091)
val itemGainMND_5092 = ItemSkillId(5092)
val itemGainCHR_5093 = ItemSkillId(5093)
val itemBoostSTR_5094 = ItemSkillId(5094)
val itemBoostDEX_5095 = ItemSkillId(5095)
val itemBoostVIT_5096 = ItemSkillId(5096)
val itemBoostAGI_5097 = ItemSkillId(5097)
val itemBoostINT_5098 = ItemSkillId(5098)
val itemBoostMND_5099 = ItemSkillId(5099)
val itemBoostCHR_5100 = ItemSkillId(5100)
val itemArise_5101 = ItemSkillId(5101)
val itemFoil_5102 = ItemSkillId(5102)
val itemCrusade_5103 = ItemSkillId(5103)
val itemFlurry_5104 = ItemSkillId(5104)
val itemFlurryII_5105 = ItemSkillId(5105)
val itemInundation_5106 = ItemSkillId(5106)
val itemFrayedSackA1_5109 = ItemSkillId(5109)
val itemFrayedSackA2_5110 = ItemSkillId(5110)
val itemFrayedSackM1_5111 = ItemSkillId(5111)
val itemFrayedSackM2_5112 = ItemSkillId(5112)
val itemCrackedNut_5113 = ItemSkillId(5113)
val itemMoistRolanberry_5114 = ItemSkillId(5114)
val itemRMokoGrass_5115 = ItemSkillId(5115)
val itemCavortingWorm_5116 = ItemSkillId(5116)
val itemLevigatedRock_5117 = ItemSkillId(5117)
val itemLittleLugworm_5118 = ItemSkillId(5118)
val itemTrainingManual_5119 = ItemSkillId(5119)
val itemTitanicSawfish_5120 = ItemSkillId(5120)
val itemMoorishIdol_5121 = ItemSkillId(5121)
val itemBibikiSlug_5122 = ItemSkillId(5122)
val itemJacknife_5123 = ItemSkillId(5123)
val itemTropicalClam_5124 = ItemSkillId(5124)
val itemPhanauetNewt_5125 = ItemSkillId(5125)
val itemMuddySiredon_5126 = ItemSkillId(5126)
val itemGugrusaurus_5127 = ItemSkillId(5127)
val itemConeCalamary_5128 = ItemSkillId(5128)
val itemLik_5129 = ItemSkillId(5129)
val itemTavnazianGoby_5130 = ItemSkillId(5130)
val itemVongolaClam_5131 = ItemSkillId(5131)
val itemGurnard_5132 = ItemSkillId(5132)
val itemPterygotus_5133 = ItemSkillId(5133)
val itemMolaMola_5134 = ItemSkillId(5134)
val itemRhinochimera_5135 = ItemSkillId(5135)
val itemIstavrit_5136 = ItemSkillId(5136)
val itemTurnabaligi_5137 = ItemSkillId(5137)
val itemBlackGhost_5138 = ItemSkillId(5138)
val itemBetta_5139 = ItemSkillId(5139)
val itemKalkanbaligi_5140 = ItemSkillId(5140)
val itemVeydalWrasse_5141 = ItemSkillId(5141)
val itemBisonSteak_5142 = ItemSkillId(5142)
val itemGoblinStirFry_5143 = ItemSkillId(5143)
val itemCrimsonJelly_5144 = ItemSkillId(5144)
val itemFishChips_5145 = ItemSkillId(5145)
val itemHedgehogPie_5146 = ItemSkillId(5146)
val itemSnollGelato_5147 = ItemSkillId(5147)
val itemSquidSushi_5148 = ItemSkillId(5148)
val itemSoleSushi_5149 = ItemSkillId(5149)
val itemTunaSushi_5150 = ItemSkillId(5150)
val itemUrchinSushi_5151 = ItemSkillId(5151)
val itemBuffaloMeat_5152 = ItemSkillId(5152)
val itemFtyTunaSushi_5153 = ItemSkillId(5153)
val itemTavnazianLiver_5154 = ItemSkillId(5154)
val itemSubzeroGelato_5155 = ItemSkillId(5155)
val itemPorcupinePie_5156 = ItemSkillId(5156)
val itemMarbledSteak_5157 = ItemSkillId(5157)
val itemVermillionJelly_5158 = ItemSkillId(5158)
val itemFritureMisareaux_5159 = ItemSkillId(5159)
val itemUrchinSushi1_5160 = ItemSkillId(5160)
val itemLeadafry_5161 = ItemSkillId(5161)
val itemSquidSushi1_5162 = ItemSkillId(5162)
val itemSoleSushi1_5163 = ItemSkillId(5163)
val itemGroundWasabi_5164 = ItemSkillId(5164)
val itemMovalWater_5165 = ItemSkillId(5165)
val itemCoeurlSub_5166 = ItemSkillId(5166)
val itemCoeurlSub1_5167 = ItemSkillId(5167)
val itemBataquiche_5168 = ItemSkillId(5168)
val itemBataquiche1_5169 = ItemSkillId(5169)
val itemGreenQuiche_5170 = ItemSkillId(5170)
val itemEmeraldQuiche_5171 = ItemSkillId(5171)
val itemWindurstTaco_5172 = ItemSkillId(5172)
val itemTTimbersTaco_5173 = ItemSkillId(5173)
val itemTavnazianTaco_5174 = ItemSkillId(5174)
val itemLeremieuTaco_5175 = ItemSkillId(5175)
val itemBreamSushi_5176 = ItemSkillId(5176)
val itemBreamSushi1_5177 = ItemSkillId(5177)
val itemDoradoSushi_5178 = ItemSkillId(5178)
val itemDoradoSushi1_5179 = ItemSkillId(5179)
val itemSophicStew_5180 = ItemSkillId(5180)
val itemTortillaBuena_5181 = ItemSkillId(5181)
val itemSaltyBretzel_5182 = ItemSkillId(5182)
val itemVikingHerring_5183 = ItemSkillId(5183)
val itemVeganSaute_5184 = ItemSkillId(5184)
val itemLeremieuSalad_5185 = ItemSkillId(5185)
val itemYahataSushi_5186 = ItemSkillId(5186)
val itemElshimoCoconut_5187 = ItemSkillId(5187)
val itemPeperoncino_5188 = ItemSkillId(5188)
val itemVongoleRosso_5189 = ItemSkillId(5189)
val itemCarbonara_5190 = ItemSkillId(5190)
val itemPescatora_5191 = ItemSkillId(5191)
val itemBoscaiola_5192 = ItemSkillId(5192)
val itemNerodiSeppia_5193 = ItemSkillId(5193)
val itemPomodoroSauce_5194 = ItemSkillId(5194)
val itemMisxParsley_5195 = ItemSkillId(5195)
val itemBuffaloJerky_5196 = ItemSkillId(5196)
val itemPeperoncino1_5197 = ItemSkillId(5197)
val itemVongoleRosso1_5198 = ItemSkillId(5198)
val itemCarbonara1_5199 = ItemSkillId(5199)
val itemPescatora1_5200 = ItemSkillId(5200)
val itemBoscaiola1_5201 = ItemSkillId(5201)
val itemNeroSeppia1_5202 = ItemSkillId(5202)
val itemHumeMochi_5203 = ItemSkillId(5203)
val itemElvaanMochi_5204 = ItemSkillId(5204)
val itemTarutaruMochi_5205 = ItemSkillId(5205)
val itemGalkaMochi_5206 = ItemSkillId(5206)
val itemBisonJerky_5207 = ItemSkillId(5207)
val itemTavRamMeat_5208 = ItemSkillId(5208)
val itemDiatrymaMeat_5209 = ItemSkillId(5209)
val itemAdamantoiseSoup_5210 = ItemSkillId(5210)
val itemArrabbiata_5211 = ItemSkillId(5211)
val itemArrabbiata1_5212 = ItemSkillId(5212)
val itemMelanzane_5213 = ItemSkillId(5213)
val itemMelanzane1_5214 = ItemSkillId(5214)
val itemTentacleSushi_5215 = ItemSkillId(5215)
val itemTentacleSushi1_5216 = ItemSkillId(5216)
val itemSalmonEggs_5217 = ItemSkillId(5217)
val itemSalmonRoe_5218 = ItemSkillId(5218)
val itemIkraGunkan_5219 = ItemSkillId(5219)
val itemIkraGunkan1_5220 = ItemSkillId(5220)
val itemHmdHerbalTea_5221 = ItemSkillId(5221)
val itemHomemadeStew_5222 = ItemSkillId(5222)
val itemHmdGelato_5223 = ItemSkillId(5223)
val itemHmdRiceBall_5224 = ItemSkillId(5224)
val itemHmdCheese_5225 = ItemSkillId(5225)
val itemHmdSteak_5226 = ItemSkillId(5226)
val itemHomemadeSalad_5227 = ItemSkillId(5227)
val itemHmdBread_5228 = ItemSkillId(5228)
val itemHmdRisotto_5229 = ItemSkillId(5229)
val itemLoveChocolate_5230 = ItemSkillId(5230)
val itemTrueloveChoco_5231 = ItemSkillId(5231)
val itemSoyMilk_5232 = ItemSkillId(5232)
val itemCottonTofu_5233 = ItemSkillId(5233)
val itemCibol_5234 = ItemSkillId(5234)
val itemNapa_5235 = ItemSkillId(5235)
val itemShungiku_5236 = ItemSkillId(5236)
val itemShirataki_5237 = ItemSkillId(5237)
val itemSeafoodStewpot_5238 = ItemSkillId(5238)
val itemPrmSfdStewpot_5239 = ItemSkillId(5239)
val itemPrzSfdStewpot_5240 = ItemSkillId(5240)
val itemGiantsDrink_5241 = ItemSkillId(5241)
val itemWizardsDrink_5242 = ItemSkillId(5242)
val itemCarnalIncense_5243 = ItemSkillId(5243)
val itemSpiritualIncense_5244 = ItemSkillId(5244)
val itemCelestialIncense_5245 = ItemSkillId(5245)
val itemDrachenessence_5246 = ItemSkillId(5246)
val itemBarfireOintment_5247 = ItemSkillId(5247)
val itemBarblizzardOint_5248 = ItemSkillId(5248)
val itemBaraeroOintment_5249 = ItemSkillId(5249)
val itemBarstoneOint_5250 = ItemSkillId(5250)
val itemBarthunderOint_5251 = ItemSkillId(5251)
val itemBarwaterOintment_5252 = ItemSkillId(5252)
val itemHermesQuencher_5253 = ItemSkillId(5253)
val itemHyperPotion_5254 = ItemSkillId(5254)
val itemHyperEther_5255 = ItemSkillId(5255)
val itemFireFeather_5256 = ItemSkillId(5256)
val itemBlazeFeather_5257 = ItemSkillId(5257)
val itemReviveFeather_5258 = ItemSkillId(5258)
val itemRebirthFeather_5259 = ItemSkillId(5259)
val itemRegainFeather_5260 = ItemSkillId(5260)
val itemPsychoanima_5261 = ItemSkillId(5261)
val itemHysteroanima_5262 = ItemSkillId(5262)
val itemTerroanima_5263 = ItemSkillId(5263)
val itemYellowLiquid_5264 = ItemSkillId(5264)
val itemMistmelt_5265 = ItemSkillId(5265)
val itemBlackenedSiredon_5266 = ItemSkillId(5266)
val itemShuMeyoSalt_5267 = ItemSkillId(5267)
val itemCCBPolymer_5268 = ItemSkillId(5268)
val itemSpecialPresent_5269 = ItemSkillId(5269)
val itemOldQuiver_5270 = ItemSkillId(5270)
val itemOldQuiver_5271 = ItemSkillId(5271)
val itemOldQuiver_5272 = ItemSkillId(5272)
val itemOldQuiver_5273 = ItemSkillId(5273)
val itemOldQuiver_5274 = ItemSkillId(5274)
val itemOldQuiver_5275 = ItemSkillId(5275)
val itemOldQuiver_5276 = ItemSkillId(5276)
val itemOldQuiver_5277 = ItemSkillId(5277)
val itemOldBoltBox_5278 = ItemSkillId(5278)
val itemOldBoltBox_5279 = ItemSkillId(5279)
val itemOldBoltBox_5280 = ItemSkillId(5280)
val itemOldBoltBox_5281 = ItemSkillId(5281)
val itemOldBoltBox_5282 = ItemSkillId(5282)
val itemOldBoltBox_5283 = ItemSkillId(5283)
val itemOldBulletBox_5284 = ItemSkillId(5284)
val itemOldBulletBox_5285 = ItemSkillId(5285)
val itemBurningCluster_5286 = ItemSkillId(5286)
val itemBitterCluster_5287 = ItemSkillId(5287)
val itemFleetingCluster_5288 = ItemSkillId(5288)
val itemProfaneCluster_5289 = ItemSkillId(5289)
val itemStartlingCluster_5290 = ItemSkillId(5290)
val itemSomberCluster_5291 = ItemSkillId(5291)
val itemRadiantCluster_5292 = ItemSkillId(5292)
val itemMalevolentCluster_5293 = ItemSkillId(5293)
val itemHRiceCake_5294 = ItemSkillId(5294)
val itemERiceCake_5295 = ItemSkillId(5295)
val itemTRiceCake_5296 = ItemSkillId(5296)
val itemMRiceCake_5297 = ItemSkillId(5297)
val itemMutingPotion_5298 = ItemSkillId(5298)
val itemSalsa_5299 = ItemSkillId(5299)
val itemBallistaRedbook_5300 = ItemSkillId(5300)
val itemRedbookPage_5301 = ItemSkillId(5301)
val itemBallistaWhitebk_5302 = ItemSkillId(5302)
val itemWhitebookPage_5303 = ItemSkillId(5303)
val itemDemoralizer_5304 = ItemSkillId(5304)
val itemDemoralizer1_5305 = ItemSkillId(5305)
val itemHallowedWater_5306 = ItemSkillId(5306)
val itemInvitriol_5307 = ItemSkillId(5307)
val itemToolbagUchi_5308 = ItemSkillId(5308)
val itemToolbagTsura_5309 = ItemSkillId(5309)
val itemToolbagKawa_5310 = ItemSkillId(5310)
val itemToolbagMaki_5311 = ItemSkillId(5311)
val itemToolbagHira_5312 = ItemSkillId(5312)
val itemToolbagMizu_5313 = ItemSkillId(5313)
val itemToolbagShihe_5314 = ItemSkillId(5314)
val itemToolbagJusa_5315 = ItemSkillId(5315)
val itemToolbagKagi_5316 = ItemSkillId(5316)
val itemToolbagSai_5317 = ItemSkillId(5317)
val itemToolbagKodo_5318 = ItemSkillId(5318)
val itemToolbagShino_5319 = ItemSkillId(5319)
val itemSmellingSalts_5320 = ItemSkillId(5320)
val itemRomancePotion_5321 = ItemSkillId(5321)
val itemHealingPowder_5322 = ItemSkillId(5322)
val itemBrennerBluebook_5323 = ItemSkillId(5323)
val itemBluebookPage_5324 = ItemSkillId(5324)
val itemBrennerBlackbk_5325 = ItemSkillId(5325)
val itemBlackbookPage_5326 = ItemSkillId(5326)
val itemPotionDrop_5327 = ItemSkillId(5327)
val itemHiPotionDrop_5328 = ItemSkillId(5328)
val itemTarutaruSnare_5329 = ItemSkillId(5329)
val itemMithraSnare_5330 = ItemSkillId(5330)
val itemQiqirnMine_5331 = ItemSkillId(5331)
val itemKaburaQuiver_5332 = ItemSkillId(5332)
val itemSleepQuiver_5333 = ItemSkillId(5333)
val itemBlnBoltQuiver_5334 = ItemSkillId(5334)
val itemAcBoltQuiver_5335 = ItemSkillId(5335)
val itemHolBoltQuiver_5336 = ItemSkillId(5336)
val itemSlpBoltQuiver_5337 = ItemSkillId(5337)
val itemVnBoltQuiver_5338 = ItemSkillId(5338)
val itemBldBoltQuiver_5339 = ItemSkillId(5339)
val itemSilvBulPouch_5340 = ItemSkillId(5340)
val itemSparBulPouch_5341 = ItemSkillId(5341)
val itemCorBullPouch_5342 = ItemSkillId(5342)
val itemAzouphFireflies_5343 = ItemSkillId(5343)
val itemBhaflauFireflies_5344 = ItemSkillId(5344)
val itemZhayolmFireflies_5345 = ItemSkillId(5345)
val itemDvuccaFireflies_5346 = ItemSkillId(5346)
val itemReefFireflies_5347 = ItemSkillId(5347)
val itemUnRuinsFireflies_5348 = ItemSkillId(5348)
val itemCutterFireflies_5349 = ItemSkillId(5349)
val itemVolantSerum_5350 = ItemSkillId(5350)
val itemOsseousSerum_5351 = ItemSkillId(5351)
val itemSpectralSerum_5352 = ItemSkillId(5352)
val itemIronBullPouch_5353 = ItemSkillId(5353)
val itemWalahraWater_5354 = ItemSkillId(5354)
val itemElixirVitae_5355 = ItemSkillId(5355)
val itemRmdyOintment_5356 = ItemSkillId(5356)
val itemEtherDrop_5357 = ItemSkillId(5357)
val itemHiEtherDrop_5358 = ItemSkillId(5358)
val itemBrzBullPouch_5359 = ItemSkillId(5359)
val itemMuteppo_5360 = ItemSkillId(5360)
val itemDatechochin_5361 = ItemSkillId(5361)
val itemRainbowPowder_5362 = ItemSkillId(5362)
val itemBulletPouch_5363 = ItemSkillId(5363)
val itemTrGroundsKey_5364 = ItemSkillId(5364)
val itemIncusCell_5365 = ItemSkillId(5365)
val itemCastellanusCell_5366 = ItemSkillId(5366)
val itemCumulusCell_5367 = ItemSkillId(5367)
val itemRadiatusCell_5368 = ItemSkillId(5368)
val itemStratusCell_5369 = ItemSkillId(5369)
val itemCirrocumulusCell_5370 = ItemSkillId(5370)
val itemUndulatusCell_5371 = ItemSkillId(5371)
val itemVirgaCell_5372 = ItemSkillId(5372)
val itemDuplicatusCell_5373 = ItemSkillId(5373)
val itemOpacusCell_5374 = ItemSkillId(5374)
val itemPraecipitatioCell_5375 = ItemSkillId(5375)
val itemPannusCell_5376 = ItemSkillId(5376)
val itemFractusCell_5377 = ItemSkillId(5377)
val itemCongestusCell_5378 = ItemSkillId(5378)
val itemNimbusCell_5379 = ItemSkillId(5379)
val itemVelumCell_5380 = ItemSkillId(5380)
val itemPileusCell_5381 = ItemSkillId(5381)
val itemMediocrisCell_5382 = ItemSkillId(5382)
val itemHumilusCell_5383 = ItemSkillId(5383)
val itemSpissatusCell_5384 = ItemSkillId(5384)
val itemBarbariansDrink_5385 = ItemSkillId(5385)
val itemFightersDrink_5386 = ItemSkillId(5386)
val itemOraclesDrink_5387 = ItemSkillId(5387)
val itemAssassinsDrink_5388 = ItemSkillId(5388)
val itemSpysDrink_5389 = ItemSkillId(5389)
val itemBraversDrink_5390 = ItemSkillId(5390)
val itemSoldiersDrink_5391 = ItemSkillId(5391)
val itemChampionsDrink_5392 = ItemSkillId(5392)
val itemMonarchsDrink_5393 = ItemSkillId(5393)
val itemGnosticsDrink_5394 = ItemSkillId(5394)
val itemClericsDrink_5395 = ItemSkillId(5395)
val itemShepherdsDrink_5396 = ItemSkillId(5396)
val itemSprintersDrink_5397 = ItemSkillId(5397)
val itemZRemFireflies_5398 = ItemSkillId(5398)
val itemARemFireflies_5399 = ItemSkillId(5399)
val itemBRemFireflies_5400 = ItemSkillId(5400)
val itemSRemFireflies_5401 = ItemSkillId(5401)
val itemFireCardCase_5402 = ItemSkillId(5402)
val itemIceCardCase_5403 = ItemSkillId(5403)
val itemWindCardCase_5404 = ItemSkillId(5404)
val itemEarthCardCase_5405 = ItemSkillId(5405)
val itemThndCardCase_5406 = ItemSkillId(5406)
val itemWaterCardCase_5407 = ItemSkillId(5407)
val itemLightCardCase_5408 = ItemSkillId(5408)
val itemDarkCardCase_5409 = ItemSkillId(5409)
val itemVrtStnPouch_5410 = ItemSkillId(5410)
val itemDawnMulsum_5411 = ItemSkillId(5411)
val itemScapegoat_5412 = ItemSkillId(5412)
val itemSmolderingLamp_5413 = ItemSkillId(5413)
val itemGlowingLamp_5414 = ItemSkillId(5414)
val itemHerosReflections_5415 = ItemSkillId(5415)
val itemStlBullPouch_5416 = ItemSkillId(5416)
val itemToolbagSanja_5417 = ItemSkillId(5417)
val itemTincture_5418 = ItemSkillId(5418)
val itemBlackMine_5419 = ItemSkillId(5419)
val itemParalyzingTube_5420 = ItemSkillId(5420)
val itemSilencingTube_5421 = ItemSkillId(5421)
val itemBindingTube_5422 = ItemSkillId(5422)
val itemBottledFay_5423 = ItemSkillId(5423)
val itemSereneSerinette_5424 = ItemSkillId(5424)
val itemJoyousSerinette_5425 = ItemSkillId(5425)
val itemMazeCompass_5426 = ItemSkillId(5426)
val itemMazePearl_5427 = ItemSkillId(5427)
val itemInstantRetrace_5428 = ItemSkillId(5428)
val itemTjnWildgrass_5429 = ItemSkillId(5429)
val itemViperPotion_5430 = ItemSkillId(5430)
val itemDustyPotion_5431 = ItemSkillId(5431)
val itemDustyEther_5432 = ItemSkillId(5432)
val itemDustyElixir_5433 = ItemSkillId(5433)
val itemFanaticsDrink_5434 = ItemSkillId(5434)
val itemFoolsDrink_5435 = ItemSkillId(5435)
val itemDustyReraise_5436 = ItemSkillId(5436)
val itemStrangeMilk_5437 = ItemSkillId(5437)
val itemStrangeJuice_5438 = ItemSkillId(5438)
val itemVicarsDrink_5439 = ItemSkillId(5439)
val itemDustyWing_5440 = ItemSkillId(5440)
val itemAngelwing_5441 = ItemSkillId(5441)
val itemThunderguardDart_5442 = ItemSkillId(5442)
val itemMgStonePouch_5443 = ItemSkillId(5443)
val itemGraubergGreens_5444 = ItemSkillId(5444)
val itemPrismaticElixir_5445 = ItemSkillId(5445)
val itemRedBubbleEye_5446 = ItemSkillId(5446)
val itemDenizanasi_5447 = ItemSkillId(5447)
val itemKalamar_5448 = ItemSkillId(5448)
val itemHamsi_5449 = ItemSkillId(5449)
val itemLakerda_5450 = ItemSkillId(5450)
val itemKilicbaligi_5451 = ItemSkillId(5451)
val itemUskumru_5452 = ItemSkillId(5452)
val itemIstakoz_5453 = ItemSkillId(5453)
val itemMercanbaligi_5454 = ItemSkillId(5454)
val itemAhtapot_5455 = ItemSkillId(5455)
val itemIstiridye_5456 = ItemSkillId(5456)
val itemDil_5457 = ItemSkillId(5457)
val itemYilanbaligi_5458 = ItemSkillId(5458)
val itemSazanbaligi_5459 = ItemSkillId(5459)
val itemKayabaligi_5460 = ItemSkillId(5460)
val itemAlabaligi_5461 = ItemSkillId(5461)
val itemMorinabaligi_5462 = ItemSkillId(5462)
val itemYayinbaligi_5463 = ItemSkillId(5463)
val itemKaplumbaga_5464 = ItemSkillId(5464)
val itemCaedarvaFrog_5465 = ItemSkillId(5465)
val itemTrumpetShell_5466 = ItemSkillId(5466)
val itemMegalodon_5467 = ItemSkillId(5467)
val itemMatsya_5468 = ItemSkillId(5468)
val itemBrassLoach_5469 = ItemSkillId(5469)
val itemPirarucu_5470 = ItemSkillId(5470)
val itemGerrothorax_5471 = ItemSkillId(5471)
val itemGarpike_5472 = ItemSkillId(5472)
val itemBastoreSweeper_5473 = ItemSkillId(5473)
val itemCaCuong_5474 = ItemSkillId(5474)
val itemGigantOctopus_5475 = ItemSkillId(5475)
val itemAbaia_5476 = ItemSkillId(5476)
val itemWarriorDie_5477 = ItemSkillId(5477)
val itemMonkDie_5478 = ItemSkillId(5478)
val itemWhiteMageDie_5479 = ItemSkillId(5479)
val itemBlackMageDie_5480 = ItemSkillId(5480)
val itemRedMageDie_5481 = ItemSkillId(5481)
val itemThiefDie_5482 = ItemSkillId(5482)
val itemPaladinDie_5483 = ItemSkillId(5483)
val itemDarkKnightDie_5484 = ItemSkillId(5484)
val itemBeastmasterDie_5485 = ItemSkillId(5485)
val itemBardDie_5486 = ItemSkillId(5486)
val itemRangerDie_5487 = ItemSkillId(5487)
val itemSamuraiDie_5488 = ItemSkillId(5488)
val itemNinjaDie_5489 = ItemSkillId(5489)
val itemDragoonDie_5490 = ItemSkillId(5490)
val itemSummonerDie_5491 = ItemSkillId(5491)
val itemBlueMageDie_5492 = ItemSkillId(5492)
val itemCorsairDie_5493 = ItemSkillId(5493)
val itemPuppetmasterDie_5494 = ItemSkillId(5494)
val itemDancerDie_5495 = ItemSkillId(5495)
val itemScholarDie_5496 = ItemSkillId(5496)
val itemBoltersDie_5497 = ItemSkillId(5497)
val itemCastersDie_5498 = ItemSkillId(5498)
val itemCoursersDie_5499 = ItemSkillId(5499)
val itemBlitzersDie_5500 = ItemSkillId(5500)
val itemTacticiansDie_5501 = ItemSkillId(5501)
val itemAlliesDie_5502 = ItemSkillId(5502)
val itemMisersDie_5503 = ItemSkillId(5503)
val itemCompanionsDie_5504 = ItemSkillId(5504)
val itemAvengersDie_5505 = ItemSkillId(5505)
val itemETinctureIB_5506 = ItemSkillId(5506)
val itemETinctureLI_5507 = ItemSkillId(5507)
val itemETinctureFI_5508 = ItemSkillId(5508)
val itemETinctureBS_5509 = ItemSkillId(5509)
val itemETinctureIS_5510 = ItemSkillId(5510)
val itemETinctureDD_5511 = ItemSkillId(5511)
val itemETinctureFF_5512 = ItemSkillId(5512)
val itemETinctureTB_5513 = ItemSkillId(5513)
val itemETinctureLL_5514 = ItemSkillId(5514)
val itemETincturePG_5515 = ItemSkillId(5515)
val itemETinctureSS_5516 = ItemSkillId(5516)
val itemETincturePF_5517 = ItemSkillId(5517)
val itemETinctureSL_5518 = ItemSkillId(5518)
val itemETincturePS_5519 = ItemSkillId(5519)
val itemETinctureSA_5520 = ItemSkillId(5520)
val itemETinctureFB_5521 = ItemSkillId(5521)
val itemETinctureSP_5522 = ItemSkillId(5522)
val itemETincturePC_5523 = ItemSkillId(5523)
val itemETinctureBB_5524 = ItemSkillId(5524)
val itemETinctureOG_5525 = ItemSkillId(5525)
val itemETinctureFrB_5526 = ItemSkillId(5526)
val itemETinctureWA_5527 = ItemSkillId(5527)
val itemETinctureCT_5528 = ItemSkillId(5528)
val itemETinctureSaS_5529 = ItemSkillId(5529)
val itemETincturePR_5530 = ItemSkillId(5530)
val itemLucereweMeat_5531 = ItemSkillId(5531)
val itemIchininKoma_5532 = ItemSkillId(5532)
val itemApkallufa_5534 = ItemSkillId(5534)
val itemDeademoiselle_5535 = ItemSkillId(5535)
val itemYorchete_5536 = ItemSkillId(5536)
val itemSoryu_5537 = ItemSkillId(5537)
val itemSekiryu_5538 = ItemSkillId(5538)
val itemHakuryu_5539 = ItemSkillId(5539)
val itemKokuryu_5540 = ItemSkillId(5540)
val itemRoyalGrape_5541 = ItemSkillId(5541)
val itemGatauxFraises_5542 = ItemSkillId(5542)
val itemMidwinterDream_5543 = ItemSkillId(5543)
val itemCrabStewpot_5544 = ItemSkillId(5544)
val itemPrmCrabStewpot_5545 = ItemSkillId(5545)
val itemPrzCrabStewpot_5546 = ItemSkillId(5546)
val itemBeefStewpot_5547 = ItemSkillId(5547)
val itemPrmBeefStewpot_5548 = ItemSkillId(5548)
val itemPrzBeefStewpot_5549 = ItemSkillId(5549)
val itemBucheauChoco_5550 = ItemSkillId(5550)
val itemSylvanExcursion_5551 = ItemSkillId(5551)
val itemBlackPudding_5552 = ItemSkillId(5552)
val itemDuskyIndulgence_5553 = ItemSkillId(5553)
val itemSquirrelsDelight_5554 = ItemSkillId(5554)
val itemFlurryCourante_5555 = ItemSkillId(5555)
val itemSeraphsKiss_5556 = ItemSkillId(5556)
val itemMontBlanc_5557 = ItemSkillId(5557)
val itemGoldenRoyale_5558 = ItemSkillId(5558)
val itemMilleFeuille_5559 = ItemSkillId(5559)
val itemElysianEclair_5560 = ItemSkillId(5560)
val itemMooglePie_5561 = ItemSkillId(5561)
val itemWhiteHoney_5562 = ItemSkillId(5562)
val itemOrobonMeat_5563 = ItemSkillId(5563)
val itemHydraMeat_5564 = ItemSkillId(5564)
val itemCerberusMeat_5565 = ItemSkillId(5565)
val itemDate_5566 = ItemSkillId(5566)
val itemDriedDate_5567 = ItemSkillId(5567)
val itemApkalluEgg_5568 = ItemSkillId(5568)
val itemPukEgg_5569 = ItemSkillId(5569)
val itemChai_5570 = ItemSkillId(5570)
val itemKarakulMeat_5571 = ItemSkillId(5571)
val itemIrmikHelvasi_5572 = ItemSkillId(5572)
val itemIrmikHelvasi1_5573 = ItemSkillId(5573)
val itemDriedDate1_5574 = ItemSkillId(5574)
val itemYogurt_5575 = ItemSkillId(5575)
val itemAyran_5576 = ItemSkillId(5576)
val itemSutlac_5577 = ItemSkillId(5577)
val itemSutlac1_5578 = ItemSkillId(5578)
val itemYaylaCorbasi_5579 = ItemSkillId(5579)
val itemYaylaCorbasi1_5580 = ItemSkillId(5580)
val itemZizMeat_5581 = ItemSkillId(5581)
val itemPatlicanSalata_5582 = ItemSkillId(5582)
val itemPatlicanSalata1_5583 = ItemSkillId(5583)
val itemIcPilav_5584 = ItemSkillId(5584)
val itemIcPilav1_5585 = ItemSkillId(5585)
val itemMenemen_5586 = ItemSkillId(5586)
val itemMenemen1_5587 = ItemSkillId(5587)
val itemKarniYarik_5588 = ItemSkillId(5588)
val itemKarniYarik1_5589 = ItemSkillId(5589)
val itemBalikSandvici_5590 = ItemSkillId(5590)
val itemBlkSandvici1_5591 = ItemSkillId(5591)
val itemImperialCoffee_5592 = ItemSkillId(5592)
val itemImperialCoffee1_5593 = ItemSkillId(5593)
val itemChai1_5594 = ItemSkillId(5594)
val itemNashmauStew_5595 = ItemSkillId(5595)
val itemSimit_5596 = ItemSkillId(5596)
val itemSimit1_5597 = ItemSkillId(5597)
val itemSisKebabi_5598 = ItemSkillId(5598)
val itemSisKebabi1_5599 = ItemSkillId(5599)
val itemBalikSis_5600 = ItemSkillId(5600)
val itemBalikSis1_5601 = ItemSkillId(5601)
val itemHydraKofte_5602 = ItemSkillId(5602)
val itemHydraKofte1_5603 = ItemSkillId(5603)
val itemElPachiraFruit_5604 = ItemSkillId(5604)
val itemSharugGreens_5605 = ItemSkillId(5605)
val itemAzouphGreens_5606 = ItemSkillId(5606)
val itemVompCarrot_5607 = ItemSkillId(5607)
val itemZeghamCarrot_5608 = ItemSkillId(5608)
val itemHellsteak_5609 = ItemSkillId(5609)
val itemHellsteak1_5610 = ItemSkillId(5610)
val itemAnglerStewpot_5611 = ItemSkillId(5611)
val itemPrmAngStewpot_5612 = ItemSkillId(5612)
val itemPrzAngStewpot_5613 = ItemSkillId(5613)
val itemKonigskuchen_5614 = ItemSkillId(5614)
val itemUberkuchen_5615 = ItemSkillId(5615)
val itemLebkuchenHouse_5616 = ItemSkillId(5616)
val itemLebkuchenManse_5617 = ItemSkillId(5617)
val itemZoni_5618 = ItemSkillId(5618)
val itemZestyZoni_5619 = ItemSkillId(5619)
val itemRoastTurkey_5620 = ItemSkillId(5620)
val itemCandyRing_5621 = ItemSkillId(5621)
val itemCandyCane_5622 = ItemSkillId(5622)
val itemTonnoRosso_5623 = ItemSkillId(5623)
val itemTonnoRosso1_5624 = ItemSkillId(5624)
val itemMapleCake_5625 = ItemSkillId(5625)
val itemSilkenSiesta_5626 = ItemSkillId(5626)
val itemYogurtCake_5627 = ItemSkillId(5627)
val itemSilkenSmile_5628 = ItemSkillId(5628)
val itemOrangeCake_5629 = ItemSkillId(5629)
val itemSilkenSqueeze_5630 = ItemSkillId(5630)
val itemPumpkinCake_5631 = ItemSkillId(5631)
val itemSilkenSash_5632 = ItemSkillId(5632)
val itemChocolateCake_5633 = ItemSkillId(5633)
val itemSilkenSpirit_5634 = ItemSkillId(5634)
val itemShrimpCracker_5635 = ItemSkillId(5635)
val itemShrCracker1_5636 = ItemSkillId(5636)
val itemPogaca_5637 = ItemSkillId(5637)
val itemPogaca1_5638 = ItemSkillId(5638)
val itemMPChicken_5639 = ItemSkillId(5639)
val itemMPCracker_5640 = ItemSkillId(5640)
val itemMPDumpling_5641 = ItemSkillId(5641)
val itemCilbir_5642 = ItemSkillId(5642)
val itemCibariousCilbir_5643 = ItemSkillId(5643)
val itemJackoPie_5644 = ItemSkillId(5644)
val itemWitchNougat_5645 = ItemSkillId(5645)
val itemBldChocolate_5646 = ItemSkillId(5646)
val itemLikKabob_5647 = ItemSkillId(5647)
val itemGrilledLik_5648 = ItemSkillId(5648)
val itemRoastedAlmonds_5649 = ItemSkillId(5649)
val itemNopales_5650 = ItemSkillId(5650)
val itemBurdock_5651 = ItemSkillId(5651)
val itemAnchovy_5652 = ItemSkillId(5652)
val itemCherryMuffin_5653 = ItemSkillId(5653)
val itemCherryMuffin1_5654 = ItemSkillId(5654)
val itemCoffeeMuffin_5655 = ItemSkillId(5655)
val itemCoffMuffin1_5656 = ItemSkillId(5656)
val itemArmyBiscuit_5657 = ItemSkillId(5657)
val itemOrtolana_5658 = ItemSkillId(5658)
val itemOrtolana1_5659 = ItemSkillId(5659)
val itemPepperoni_5660 = ItemSkillId(5660)
val itemWalnut_5661 = ItemSkillId(5661)
val itemDragonFruit_5662 = ItemSkillId(5662)
val itemSalmonSushi_5663 = ItemSkillId(5663)
val itemSalmonSushi1_5664 = ItemSkillId(5664)
val itemFinSushi_5665 = ItemSkillId(5665)
val itemFinSushi1_5666 = ItemSkillId(5666)
val itemLynxMeat_5667 = ItemSkillId(5667)
val itemSmilodonLiver_5668 = ItemSkillId(5668)
val itemLoachSlop_5669 = ItemSkillId(5669)
val itemLoachGruel_5670 = ItemSkillId(5670)
val itemLoachSoup_5671 = ItemSkillId(5671)
val itemDriedBerry_5672 = ItemSkillId(5672)
val itemRolsin_5673 = ItemSkillId(5673)
val itemAileensDelight_5674 = ItemSkillId(5674)
val itemWitheredBerry_5675 = ItemSkillId(5675)
val itemMushroomSaute_5676 = ItemSkillId(5676)
val itemPatriarchSaute_5677 = ItemSkillId(5677)
val itemMushroomSalad_5678 = ItemSkillId(5678)
val itemCathedralSalad_5679 = ItemSkillId(5679)
val itemAgaricus_5680 = ItemSkillId(5680)
val itemCupidChocolate_5681 = ItemSkillId(5681)
val itemPurplePolypore_5682 = ItemSkillId(5682)
val itemHumptyDumpty_5683 = ItemSkillId(5683)
val itemChalaimbille_5684 = ItemSkillId(5684)
val itemRabbitPie_5685 = ItemSkillId(5685)
val itemCheeseSandwich_5686 = ItemSkillId(5686)
val itemCheeseSand1_5687 = ItemSkillId(5687)
val itemGraubgLettuce_5688 = ItemSkillId(5688)
val itemMeatloaf_5689 = ItemSkillId(5689)
val itemMeatloaf1_5690 = ItemSkillId(5690)
val itemShrimpSushi_5691 = ItemSkillId(5691)
val itemShrimpSushi1_5692 = ItemSkillId(5692)
val itemOctopusSushi_5693 = ItemSkillId(5693)
val itemOctopusSushi1_5694 = ItemSkillId(5694)
val itemMargheritaPizza_5695 = ItemSkillId(5695)
val itemMargPizza1_5696 = ItemSkillId(5696)
val itemPepperoniPizza_5697 = ItemSkillId(5697)
val itemPeppPizza1_5698 = ItemSkillId(5698)
val itemAnchovyPizza_5699 = ItemSkillId(5699)
val itemAnchPizza1_5700 = ItemSkillId(5700)
val itemNopalesSalad_5701 = ItemSkillId(5701)
val itemNopalesSalad1_5702 = ItemSkillId(5702)
val itemUleguerandMilk_5703 = ItemSkillId(5703)
val itemAnglersCassoulet_5704 = ItemSkillId(5704)
val itemHmdSalisSteak_5705 = ItemSkillId(5705)
val itemHmdCarbonara_5706 = ItemSkillId(5706)
val itemHmdOmelette_5707 = ItemSkillId(5707)
val itemMihgoMithkabob_5708 = ItemSkillId(5708)
val itemCottonCandy_5709 = ItemSkillId(5709)
val itemBSnowCone_5710 = ItemSkillId(5710)
val itemKSnowCone_5711 = ItemSkillId(5711)
val itemMSnowCone_5712 = ItemSkillId(5712)
val itemOSnowCone_5713 = ItemSkillId(5713)
val itemPearlscale_5714 = ItemSkillId(5714)
val itemCalicoComet_5715 = ItemSkillId(5715)
val itemSoothingPotion_5716 = ItemSkillId(5716)
val itemMPDonerKeb_5717 = ItemSkillId(5717)
val itemCreamPuff_5718 = ItemSkillId(5718)
val itemMarinara_5719 = ItemSkillId(5719)
val itemMarinara1_5720 = ItemSkillId(5720)
val itemCrabSushi_5721 = ItemSkillId(5721)
val itemCrabSushi1_5722 = ItemSkillId(5722)
val itemPungentPowder_5724 = ItemSkillId(5724)
val itemGoshikitenge_5725 = ItemSkillId(5725)
val itemZucchini_5726 = ItemSkillId(5726)
val itemZaruSoba_5727 = ItemSkillId(5727)
val itemZaruSoba1_5728 = ItemSkillId(5728)
val itemBavarois_5729 = ItemSkillId(5729)
val itemBavarois1_5730 = ItemSkillId(5730)
val itemRatatouille_5731 = ItemSkillId(5731)
val itemRatatouille1_5732 = ItemSkillId(5732)
val itemMiracleMilk_5733 = ItemSkillId(5733)
val itemToolbagSoshi_5734 = ItemSkillId(5734)
val itemCtnPurseAlx_5735 = ItemSkillId(5735)
val itemLinPurseAlx_5736 = ItemSkillId(5736)
val itemSaltedHare_5737 = ItemSkillId(5737)
val itemSweetLizard_5738 = ItemSkillId(5738)
val itemHoneyedEgg_5739 = ItemSkillId(5739)
val itemPaprika_5740 = ItemSkillId(5740)
val itemPestRepellent_5741 = ItemSkillId(5741)
val itemBBRanchMilk_5742 = ItemSkillId(5742)
val itemMarinaraPizza_5743 = ItemSkillId(5743)
val itemMarinaraPizza1_5744 = ItemSkillId(5744)
val itemCherryBavarois_5745 = ItemSkillId(5745)
val itemCherryBavarois1_5746 = ItemSkillId(5746)
val itemMarinaraSauce_5747 = ItemSkillId(5747)
val itemSachetofWood_5748 = ItemSkillId(5748)
val itemSachetofBugs_5749 = ItemSkillId(5749)
val itemGoulash_5750 = ItemSkillId(5750)
val itemGoulash1_5751 = ItemSkillId(5751)
val itemPotaufeu_5752 = ItemSkillId(5752)
val itemPotaufeu1_5753 = ItemSkillId(5753)
val itemEaudeMoblin_5754 = ItemSkillId(5754)
val itemRuszorMeat_5755 = ItemSkillId(5755)
val itemGreenCurryBun_5756 = ItemSkillId(5756)
val itemYlwCurryBun_5757 = ItemSkillId(5757)
val itemBlackCurryBun_5758 = ItemSkillId(5758)
val itemRedCurryBun_5759 = ItemSkillId(5759)
val itemKohlrouladen_5760 = ItemSkillId(5760)
val itemKohlrouladen1_5761 = ItemSkillId(5761)
val itemGCurryBun1_5762 = ItemSkillId(5762)
val itemYCurryBun1_5763 = ItemSkillId(5763)
val itemBCurryBun1_5764 = ItemSkillId(5764)
val itemRCurryBun1_5765 = ItemSkillId(5765)
val itemButterCrepe_5766 = ItemSkillId(5766)
val itemCrepeDelice_5767 = ItemSkillId(5767)
val itemMagianSpecs_5768 = ItemSkillId(5768)
val itemPopper_5769 = ItemSkillId(5769)
val itemSuperReraiser_5770 = ItemSkillId(5770)
val itemHamChCrepe_5771 = ItemSkillId(5771)
val itemCrepePaysanne_5772 = ItemSkillId(5772)
val itemMushroomCrepe_5773 = ItemSkillId(5773)
val itemCrepeForestiere_5774 = ItemSkillId(5774)
val itemChocolateCrepe_5775 = ItemSkillId(5775)
val itemCrepeCaprice_5776 = ItemSkillId(5776)
val itemPearCrepe_5777 = ItemSkillId(5777)
val itemCrepeBHelene_5778 = ItemSkillId(5778)
val itemCherryMacaron_5779 = ItemSkillId(5779)
val itemCoffeeMacaron_5780 = ItemSkillId(5780)
val itemKitronMacaron_5781 = ItemSkillId(5781)
val itemSugarRusk_5782 = ItemSkillId(5782)
val itemChocolateRusk_5783 = ItemSkillId(5783)
val itemCoconutRusk_5784 = ItemSkillId(5784)
val itemCrayfish_5785 = ItemSkillId(5785)
val itemDarkBass_5786 = ItemSkillId(5786)
val itemPipira_5787 = ItemSkillId(5787)
val itemBlackEel_5788 = ItemSkillId(5788)
val itemMoatCarp_5789 = ItemSkillId(5789)
val itemCopperFrog_5790 = ItemSkillId(5790)
val itemShiningTrout_5791 = ItemSkillId(5791)
val itemBastoreSardine_5792 = ItemSkillId(5792)
val itemQuus_5793 = ItemSkillId(5793)
val itemTigerCod_5794 = ItemSkillId(5794)
val itemOgreEel_5795 = ItemSkillId(5795)
val itemNosteauHerring_5796 = ItemSkillId(5796)
val itemGoldLobster_5797 = ItemSkillId(5797)
val itemBluetail_5798 = ItemSkillId(5798)
val itemGiantCatfish_5799 = ItemSkillId(5799)
val itemGiantDonko_5800 = ItemSkillId(5800)
val itemMonkeOnke_5801 = ItemSkillId(5801)
val itemIstavrit_5802 = ItemSkillId(5802)
val itemGigantOctopus_5803 = ItemSkillId(5803)
val itemVeydalWrasse_5804 = ItemSkillId(5804)
val itemGugruTuna_5805 = ItemSkillId(5805)
val itemBhefhelMarlin_5806 = ItemSkillId(5806)
val itemBladefish_5807 = ItemSkillId(5807)
val itemRhinochimera_5808 = ItemSkillId(5808)
val itemThreeeyedFish_5809 = ItemSkillId(5809)
val itemMoatCarpCreel_5810 = ItemSkillId(5810)
val itemForestCarpCreel_5811 = ItemSkillId(5811)
val itemBlowfish_5812 = ItemSkillId(5812)
val itemDoradoGar_5813 = ItemSkillId(5813)
val itemCrocodilos_5814 = ItemSkillId(5814)
val itemPelazoea_5815 = ItemSkillId(5815)
val itemKingPerch_5816 = ItemSkillId(5816)
val itemTigerShark_5817 = ItemSkillId(5817)
val itemAuroraBass_5818 = ItemSkillId(5818)
val itemAntlionQuiver_5819 = ItemSkillId(5819)
val itemDklBoltQuiver_5820 = ItemSkillId(5820)
val itemFsnBoltQuiver_5821 = ItemSkillId(5821)
val itemDwmBulPouch_5822 = ItemSkillId(5822)
val itemObrBullPouch_5823 = ItemSkillId(5823)
val itemLucidPotionI_5824 = ItemSkillId(5824)
val itemLucidPotionII_5825 = ItemSkillId(5825)
val itemLucidPotionIII_5826 = ItemSkillId(5826)
val itemLucidEtherI_5827 = ItemSkillId(5827)
val itemLucidEtherII_5828 = ItemSkillId(5828)
val itemLucidEtherIII_5829 = ItemSkillId(5829)
val itemLucidElixirI_5830 = ItemSkillId(5830)
val itemLucidElixirII_5831 = ItemSkillId(5831)
val itemHealingMist_5832 = ItemSkillId(5832)
val itemManaMist_5833 = ItemSkillId(5833)
val itemLucidWingsI_5834 = ItemSkillId(5834)
val itemHealingSalveI_5835 = ItemSkillId(5835)
val itemHealingSalveII_5836 = ItemSkillId(5836)
val itemClearSalveI_5837 = ItemSkillId(5837)
val itemClearSalveII_5838 = ItemSkillId(5838)
val itemStalwartsTonic_5839 = ItemSkillId(5839)
val itemStalwartsGambir_5840 = ItemSkillId(5840)
val itemAsceticsTonic_5841 = ItemSkillId(5841)
val itemAsceticsGambir_5842 = ItemSkillId(5842)
val itemChampionsTonic_5843 = ItemSkillId(5843)
val itemChampionsGambir_5844 = ItemSkillId(5844)
val itemFanaticsTonic_5845 = ItemSkillId(5845)
val itemFoolsTonic_5846 = ItemSkillId(5846)
val itemFanaticsPowder_5847 = ItemSkillId(5847)
val itemFoolsPowder_5848 = ItemSkillId(5848)
val itemBerserkersDrink_5849 = ItemSkillId(5849)
val itemSwiftshotDrink_5850 = ItemSkillId(5850)
val itemBerserkersTonic_5851 = ItemSkillId(5851)
val itemSwiftshotTonic_5852 = ItemSkillId(5852)
val itemPrimevalBrew_5853 = ItemSkillId(5853)
val itemFrayedPouchB_5854 = ItemSkillId(5854)
val itemFrayedPouchA_5855 = ItemSkillId(5855)
val itemFrayedPouchG_5856 = ItemSkillId(5856)
val itemFrayedPouchD_5857 = ItemSkillId(5857)
val itemFrayedPouchR_5858 = ItemSkillId(5858)
val itemGlkSausage1_5859 = ItemSkillId(5859)
val itemGlkSausage2_5860 = ItemSkillId(5860)
val itemGlkSausage3_5861 = ItemSkillId(5861)
val itemGlkSausage1_5862 = ItemSkillId(5862)
val itemToolbagKaben_5863 = ItemSkillId(5863)
val itemToolbagJinko_5864 = ItemSkillId(5864)
val itemToolbagRyuno_5865 = ItemSkillId(5865)
val itemToolbagMoku_5866 = ItemSkillId(5866)
val itemToolbagIno_5867 = ItemSkillId(5867)
val itemToolbagShika_5868 = ItemSkillId(5868)
val itemToolbagCho_5869 = ItemSkillId(5869)
val itemTrumpCardCase_5870 = ItemSkillId(5870)
val itemRuszorQuiver_5871 = ItemSkillId(5871)
val itemDABoltQuiver_5872 = ItemSkillId(5872)
val itemDABullPouch_5873 = ItemSkillId(5873)
val itemGalettedesRois_5875 = ItemSkillId(5875)
val itemPetrifyScreen_5876 = ItemSkillId(5876)
val itemTerrorScreen_5877 = ItemSkillId(5877)
val itemAmnesiaScreen_5878 = ItemSkillId(5878)
val itemDoomScreen_5879 = ItemSkillId(5879)
val itemPoisonScreen_5880 = ItemSkillId(5880)
val itemShisaiKaboku_5881 = ItemSkillId(5881)
val itemMarineBliss_5882 = ItemSkillId(5882)
val itemFallingStar_5883 = ItemSkillId(5883)
val itemRengedama_5884 = ItemSkillId(5884)
val itemSaltena_5885 = ItemSkillId(5885)
val itemElshena_5886 = ItemSkillId(5886)
val itemMontagna_5887 = ItemSkillId(5887)
val itemMaringna_5888 = ItemSkillId(5888)
val itemStuffedPitaru_5889 = ItemSkillId(5889)
val itemPoultryPitaru_5890 = ItemSkillId(5890)
val itemSeafoodPitaru_5891 = ItemSkillId(5891)
val itemBEWPitaru_5892 = ItemSkillId(5892)
val itemMarineStewpot_5893 = ItemSkillId(5893)
val itemPrmMnStewpot_5894 = ItemSkillId(5894)
val itemOdorlessFungus_5895 = ItemSkillId(5895)
val itemAbsorbentMoss_5896 = ItemSkillId(5896)
val itemRedolentRoot_5897 = ItemSkillId(5897)
val itemShadescaleSkull_5898 = ItemSkillId(5898)
val itemShadescaleFemur_5899 = ItemSkillId(5899)
val itemShadescaleTalon_5900 = ItemSkillId(5900)
val itemShadescaleHeart_5901 = ItemSkillId(5901)
val itemCagebeastBlood_5902 = ItemSkillId(5902)
val itemSeaMonkVenom_5903 = ItemSkillId(5903)
val itemPerforatedWing_5904 = ItemSkillId(5904)
val itemUndyingMoiety_5905 = ItemSkillId(5905)
val itemAbdhaljsonWar_5906 = ItemSkillId(5906)
val itemWinterflower_5907 = ItemSkillId(5907)
val itemButterpear_5908 = ItemSkillId(5908)
val itemPickledRTail_5909 = ItemSkillId(5909)
val itemHvyMetalPouch_5910 = ItemSkillId(5910)
val itemOldeRarabTail_5911 = ItemSkillId(5911)
val itemGargouQuiver_5912 = ItemSkillId(5912)
val itemABoltQuiver_5913 = ItemSkillId(5913)
val itemOBullPouch_5914 = ItemSkillId(5914)
val itemABullPouch_5915 = ItemSkillId(5915)
val itemTempleTruffle_5916 = ItemSkillId(5916)
val itemChocoscroll_5917 = ItemSkillId(5917)
val itemChocokatana_5918 = ItemSkillId(5918)
val itemChocoligar_5919 = ItemSkillId(5919)
val itemFudgyWudge_5920 = ItemSkillId(5920)
val itemChocoRTail_5921 = ItemSkillId(5921)
val itemWalnutCookie_5922 = ItemSkillId(5922)
val itemJuglanJumble_5923 = ItemSkillId(5923)
val itemSSalisSteak_5924 = ItemSkillId(5924)
val itemCSalisSteak_5925 = ItemSkillId(5925)
val itemDateTea_5926 = ItemSkillId(5926)
val itemCaravanTea_5927 = ItemSkillId(5927)
val itemHimesamaRBall_5928 = ItemSkillId(5928)
val itemOjoRiceBall_5929 = ItemSkillId(5929)
val itemSprightlySoup_5930 = ItemSkillId(5930)
val itemShimmySoup_5931 = ItemSkillId(5931)
val itemKitronJuice_5932 = ItemSkillId(5932)
val itemDFruitauLait_5933 = ItemSkillId(5933)
val itemChocobiscuit_5934 = ItemSkillId(5934)
val itemMoogurt_5935 = ItemSkillId(5935)
val itemMogMissile_5936 = ItemSkillId(5936)
val itemBubbleBreeze_5937 = ItemSkillId(5937)
val itemHiatusWhistle_5938 = ItemSkillId(5938)
val itemTerminusWhistle_5939 = ItemSkillId(5939)
val itemTrailCookie_5940 = ItemSkillId(5940)
val itemCampfireChoco_5941 = ItemSkillId(5941)
val itemCascadeCandy_5942 = ItemSkillId(5942)
val itemSmokedMackerel_5943 = ItemSkillId(5943)
val itemFrontierSoda_5944 = ItemSkillId(5944)
val itemPrizePowder_5945 = ItemSkillId(5945)
val itemFrayedSackD_5946 = ItemSkillId(5946)
val itemFrayedSackL_5947 = ItemSkillId(5947)
val itemBlackPrawn_5948 = ItemSkillId(5948)
val itemMussel_5949 = ItemSkillId(5949)
val itemMackerel_5950 = ItemSkillId(5950)
val itemBloodblotch_5951 = ItemSkillId(5951)
val itemRuddySeema_5952 = ItemSkillId(5952)
val itemDragonflyTrout_5953 = ItemSkillId(5953)
val itemBarnacle_5954 = ItemSkillId(5954)
val itemYawningCatfish_5955 = ItemSkillId(5955)
val itemShockfish_5957 = ItemSkillId(5957)
val itemDragonfish_5959 = ItemSkillId(5959)
val itemUlbukanLobster_5960 = ItemSkillId(5960)
val itemContortopus_5961 = ItemSkillId(5961)
val itemContortacle_5962 = ItemSkillId(5962)
val itemSenrohSardine_5963 = ItemSkillId(5963)
val itemFelicifruit_5964 = ItemSkillId(5964)
val itemIsleracea_5965 = ItemSkillId(5965)
val itemUlbuconut_5966 = ItemSkillId(5966)
val itemVerboshroom_5967 = ItemSkillId(5967)
val itemSeafoodPaella_5968 = ItemSkillId(5968)
val itemPiscatorsPaella_5969 = ItemSkillId(5969)
val itemMushroomPaella_5970 = ItemSkillId(5970)
val itemMushPaella1_5971 = ItemSkillId(5971)
val itemBeefPaella_5972 = ItemSkillId(5972)
val itemBeefPaella1_5973 = ItemSkillId(5973)
val itemBarnaclePaella_5974 = ItemSkillId(5974)
val itemFlapanosPaella_5975 = ItemSkillId(5975)
val itemUlbuconutMilk_5976 = ItemSkillId(5976)
val itemUlbuconutMilk1_5977 = ItemSkillId(5977)
val itemFelicifruitGelatin_5978 = ItemSkillId(5978)
val itemDulcetPanettones_5979 = ItemSkillId(5979)
val itemBoiledBarnacles_5980 = ItemSkillId(5980)
val itemBldBarnacles1_5981 = ItemSkillId(5981)
val itemSenrohSkewer_5982 = ItemSkillId(5982)
val itemPiscatorsSkewer_5983 = ItemSkillId(5983)
val itemGnatbane_5984 = ItemSkillId(5984)
val itemHemlock_5985 = ItemSkillId(5985)
val itemCoalitionPotion_5986 = ItemSkillId(5986)
val itemCoalitionEther_5987 = ItemSkillId(5987)
val itemInstantProtect_5988 = ItemSkillId(5988)
val itemInstantShell_5989 = ItemSkillId(5989)
val itemInstantStoneskin_5990 = ItemSkillId(5990)
val itemFarewellFly_5991 = ItemSkillId(5991)
val itemFenestralKey_5992 = ItemSkillId(5992)
val itemSenrohFrog_5993 = ItemSkillId(5993)
val itemMaliciousPerch_5995 = ItemSkillId(5995)
val itemShen_5997 = ItemSkillId(5997)
val itemAdoulinianSoup_5998 = ItemSkillId(5998)
val itemAdoulinianSoup1_5999 = ItemSkillId(5999)
val itemClotflagration_6001 = ItemSkillId(6001)
val itemTrblPickaxe_6002 = ItemSkillId(6002)
val itemTrblPickaxe1_6003 = ItemSkillId(6003)
val itemTrblHatchet_6004 = ItemSkillId(6004)
val itemTrblHatchet1_6005 = ItemSkillId(6005)
val itemTrblSickle_6006 = ItemSkillId(6006)
val itemTrblSickle1_6007 = ItemSkillId(6007)
val itemCopseCandy_6008 = ItemSkillId(6008)
val itemMogPudding_6009 = ItemSkillId(6009)
val itemSakuraBiscuit_6010 = ItemSkillId(6010)
val itemCYggShardI_6011 = ItemSkillId(6011)
val itemCYggShardII_6012 = ItemSkillId(6012)
val itemCYggShardIII_6013 = ItemSkillId(6013)
val itemCYggShardIV_6014 = ItemSkillId(6014)
val itemCYggShardV_6015 = ItemSkillId(6015)
val itemZYggShardI_6016 = ItemSkillId(6016)
val itemZYggShardII_6017 = ItemSkillId(6017)
val itemZYggShardIII_6018 = ItemSkillId(6018)
val itemZYggShardIV_6019 = ItemSkillId(6019)
val itemZYggShardV_6020 = ItemSkillId(6020)
val itemAYggShardI_6021 = ItemSkillId(6021)
val itemAYggShardII_6022 = ItemSkillId(6022)
val itemAYggShardIII_6023 = ItemSkillId(6023)
val itemAYggShardIV_6024 = ItemSkillId(6024)
val itemAYggShardV_6025 = ItemSkillId(6025)
val itemCeladonYggziI_6026 = ItemSkillId(6026)
val itemCeladonYggziII_6027 = ItemSkillId(6027)
val itemCeladonYggziIII_6028 = ItemSkillId(6028)
val itemCeladonYggziIV_6029 = ItemSkillId(6029)
val itemCeladonYggziV_6030 = ItemSkillId(6030)
val itemZaffreYggziI_6031 = ItemSkillId(6031)
val itemZaffreYggziII_6032 = ItemSkillId(6032)
val itemZaffreYggziIII_6033 = ItemSkillId(6033)
val itemZaffreYggziIV_6034 = ItemSkillId(6034)
val itemZaffreYggziV_6035 = ItemSkillId(6035)
val itemAlizarinYggziI_6036 = ItemSkillId(6036)
val itemAlizarinYggziII_6037 = ItemSkillId(6037)
val itemAlizarinYggziIII_6038 = ItemSkillId(6038)
val itemAlizarinYggziIV_6039 = ItemSkillId(6039)
val itemAlizarinYggziV_6040 = ItemSkillId(6040)
val itemPyrohelix_6041 = ItemSkillId(6041)
val itemHydrohelix_6042 = ItemSkillId(6042)
val itemIonohelix_6043 = ItemSkillId(6043)
val itemCryohelix_6044 = ItemSkillId(6044)
val itemGeohelix_6045 = ItemSkillId(6045)
val itemAnemohelix_6046 = ItemSkillId(6046)
val itemLuminohelix_6047 = ItemSkillId(6047)
val itemNoctohelix_6048 = ItemSkillId(6048)
val itemFirestorm_6049 = ItemSkillId(6049)
val itemRainstorm_6050 = ItemSkillId(6050)
val itemThunderstorm_6051 = ItemSkillId(6051)
val itemHailstorm_6052 = ItemSkillId(6052)
val itemSandstorm_6053 = ItemSkillId(6053)
val itemWindstorm_6054 = ItemSkillId(6054)
val itemAurorastorm_6055 = ItemSkillId(6055)
val itemVoidstorm_6056 = ItemSkillId(6056)
val itemKlimaform_6058 = ItemSkillId(6058)
val itemAnimusAugeo_6059 = ItemSkillId(6059)
val itemAnimusMinuo_6060 = ItemSkillId(6060)
val itemAdloquium_6061 = ItemSkillId(6061)
val itemFruitParfait_6063 = ItemSkillId(6063)
val itemQueensCrown_6064 = ItemSkillId(6064)
val itemTinyMacaron_6065 = ItemSkillId(6065)
val itemTinyRusk_6066 = ItemSkillId(6066)
val itemOnticExtremity_6067 = ItemSkillId(6067)
val itemGabbrathMeat_6068 = ItemSkillId(6068)
val itemRiverfinSoup_6069 = ItemSkillId(6069)
val itemOceanfinSoup_6070 = ItemSkillId(6070)
val itemMagmaSteak_6071 = ItemSkillId(6071)
val itemMagmaSteak1_6072 = ItemSkillId(6072)
val itemIndiRegen_6073 = ItemSkillId(6073)
val itemIndiPoison_6074 = ItemSkillId(6074)
val itemIndiRefresh_6075 = ItemSkillId(6075)
val itemIndiSTR_6076 = ItemSkillId(6076)
val itemIndiDEX_6077 = ItemSkillId(6077)
val itemIndiVIT_6078 = ItemSkillId(6078)
val itemIndiAGI_6079 = ItemSkillId(6079)
val itemIndiINT_6080 = ItemSkillId(6080)
val itemIndiMND_6081 = ItemSkillId(6081)
val itemIndiCHR_6082 = ItemSkillId(6082)
val itemIndiFury_6083 = ItemSkillId(6083)
val itemIndiBarrier_6084 = ItemSkillId(6084)
val itemIndiAcumen_6085 = ItemSkillId(6085)
val itemIndiFend_6086 = ItemSkillId(6086)
val itemIndiPrecision_6087 = ItemSkillId(6087)
val itemIndiVoidance_6088 = ItemSkillId(6088)
val itemIndiFocus_6089 = ItemSkillId(6089)
val itemIndiAttunement_6090 = ItemSkillId(6090)
val itemIndiWilt_6091 = ItemSkillId(6091)
val itemIndiFrailty_6092 = ItemSkillId(6092)
val itemIndiFade_6093 = ItemSkillId(6093)
val itemIndiMalaise_6094 = ItemSkillId(6094)
val itemIndiSlip_6095 = ItemSkillId(6095)
val itemIndiTorpor_6096 = ItemSkillId(6096)
val itemIndiVex_6097 = ItemSkillId(6097)
val itemIndiLanguor_6098 = ItemSkillId(6098)
val itemIndiSlow_6099 = ItemSkillId(6099)
val itemIndiParalysis_6100 = ItemSkillId(6100)
val itemIndiGravity_6101 = ItemSkillId(6101)
val itemGeoRegen_6102 = ItemSkillId(6102)
val itemGeoPoison_6103 = ItemSkillId(6103)
val itemGeoRefresh_6104 = ItemSkillId(6104)
val itemGeoSTR_6105 = ItemSkillId(6105)
val itemGeoDEX_6106 = ItemSkillId(6106)
val itemGeoVIT_6107 = ItemSkillId(6107)
val itemGeoAGI_6108 = ItemSkillId(6108)
val itemGeoINT_6109 = ItemSkillId(6109)
val itemGeoMND_6110 = ItemSkillId(6110)
val itemGeoCHR_6111 = ItemSkillId(6111)
val itemGeoFury_6112 = ItemSkillId(6112)
val itemGeoBarrier_6113 = ItemSkillId(6113)
val itemGeoAcumen_6114 = ItemSkillId(6114)
val itemGeoFend_6115 = ItemSkillId(6115)
val itemGeoPrecision_6116 = ItemSkillId(6116)
val itemGeoVoidance_6117 = ItemSkillId(6117)
val itemGeoFocus_6118 = ItemSkillId(6118)
val itemGeoAttunement_6119 = ItemSkillId(6119)
val itemGeoWilt_6120 = ItemSkillId(6120)
val itemGeoFrailty_6121 = ItemSkillId(6121)
val itemGeoFade_6122 = ItemSkillId(6122)
val itemGeoMalaise_6123 = ItemSkillId(6123)
val itemGeoSlip_6124 = ItemSkillId(6124)
val itemGeoTorpor_6125 = ItemSkillId(6125)
val itemGeoVex_6126 = ItemSkillId(6126)
val itemGeoLanguor_6127 = ItemSkillId(6127)
val itemGeoSlow_6128 = ItemSkillId(6128)
val itemGeoParalysis_6129 = ItemSkillId(6129)
val itemGeoGravity_6130 = ItemSkillId(6130)
val itemIndiHaste_6131 = ItemSkillId(6131)
val itemGeoHaste_6132 = ItemSkillId(6132)
val itemChapuliQuiver_6137 = ItemSkillId(6137)
val itemMantidQuiver_6138 = ItemSkillId(6138)
val itemMidBoltQuiver_6139 = ItemSkillId(6139)
val itemDmBoltQuiver_6140 = ItemSkillId(6140)
val itemOBoltQuiver_6141 = ItemSkillId(6141)
val itemMidBulPouch_6142 = ItemSkillId(6142)
val itemDmBulPouch_6143 = ItemSkillId(6143)
val itemFrigorifish_6144 = ItemSkillId(6144)
val itemDwarfRemora_6145 = ItemSkillId(6145)
val itemRemora_6146 = ItemSkillId(6146)
val itemMikhesMemo_6147 = ItemSkillId(6147)
val itemDgrEnchiridion_6148 = ItemSkillId(6148)
val itemSwingandStab_6149 = ItemSkillId(6149)
val itemMieuseloirsDiary_6150 = ItemSkillId(6150)
val itemBullsDiary_6151 = ItemSkillId(6151)
val itemDeathforDim_6152 = ItemSkillId(6152)
val itemLudwigsReport_6153 = ItemSkillId(6153)
val itemClashofTitans_6154 = ItemSkillId(6154)
val itemKagetorasDiary_6155 = ItemSkillId(6155)
val itemNoilluriesLog_6156 = ItemSkillId(6156)
val itemFerreoussDiary_6157 = ItemSkillId(6157)
val itemKPsMemoirs_6158 = ItemSkillId(6158)
val itemPerihsPrimer_6159 = ItemSkillId(6159)
val itemBarrelsofFun_6160 = ItemSkillId(6160)
val itemTWEnchiridion_6161 = ItemSkillId(6161)
val itemMikhesNote_6162 = ItemSkillId(6162)
val itemSoniasDiary_6163 = ItemSkillId(6163)
val itemTheSuccessor_6164 = ItemSkillId(6164)
val itemKageJournal_6165 = ItemSkillId(6165)
val itemAltanasHymn_6166 = ItemSkillId(6166)
val itemCoveffeMusings_6167 = ItemSkillId(6167)
val itemAidforAll_6168 = ItemSkillId(6168)
val itemInvReport_6169 = ItemSkillId(6169)
val itemBountyList_6170 = ItemSkillId(6170)
val itemDarkDeeds_6171 = ItemSkillId(6171)
val itemBreezyLibretto_6172 = ItemSkillId(6172)
val itemCavernousScore_6173 = ItemSkillId(6173)
val itemBeamingScore_6174 = ItemSkillId(6174)
val itemYomisDiagram_6175 = ItemSkillId(6175)
val itemAstralHomeland_6176 = ItemSkillId(6176)
val itemLifeformStudy_6177 = ItemSkillId(6177)
val itemHrohjsRecord_6178 = ItemSkillId(6178)
val itemTheBellTolls_6179 = ItemSkillId(6179)
val itemPlutonCase_6180 = ItemSkillId(6180)
val itemBeitetsuParcel_6181 = ItemSkillId(6181)
val itemBoulderCase_6182 = ItemSkillId(6182)
val itemPlutonBox_6183 = ItemSkillId(6183)
val itemBeitetsuBox_6184 = ItemSkillId(6184)
val itemBoulderBox_6185 = ItemSkillId(6185)
val itemSlimeRocket_6186 = ItemSkillId(6186)
val itemSlimeCandy_6187 = ItemSkillId(6187)
val itemSheSlimeCandy_6188 = ItemSkillId(6188)
val itemMSlimeCandy_6189 = ItemSkillId(6189)
val itemSprigganSpark_6190 = ItemSkillId(6190)
val itemGSpriggLolli_6191 = ItemSkillId(6191)
val itemRSpriggLolli_6192 = ItemSkillId(6192)
val itemPSpriggLolli_6193 = ItemSkillId(6193)
val itemETinctureLF_6194 = ItemSkillId(6194)
val itemETinctureLP_6195 = ItemSkillId(6195)
val itemETinctureHI_6196 = ItemSkillId(6196)
val itemETincturePRi_6197 = ItemSkillId(6197)
val itemETinctureCC_6198 = ItemSkillId(6198)
val itemAchiyalQuiver_6199 = ItemSkillId(6199)
val itemAdlivunQuiver_6200 = ItemSkillId(6200)
val itemTulfaireQuiver_6201 = ItemSkillId(6201)
val itemRaazQuiver_6202 = ItemSkillId(6202)
val itemAlBoltQuiver_6203 = ItemSkillId(6203)
val itemAdBoltQuiver_6204 = ItemSkillId(6204)
val itemTBoltQuiver_6205 = ItemSkillId(6205)
val itemBiBoltQuiver_6206 = ItemSkillId(6206)
val itemAlBullPouch_6207 = ItemSkillId(6207)
val itemAdBullPouch_6208 = ItemSkillId(6208)
val itemTiBullPouch_6209 = ItemSkillId(6209)
val itemBiBullPouch_6210 = ItemSkillId(6210)
val itemMarinaraSlice_6211 = ItemSkillId(6211)
val itemMarinaraSlice1_6212 = ItemSkillId(6212)
val itemMargheritaSlice_6213 = ItemSkillId(6213)
val itemMargSlice1_6214 = ItemSkillId(6214)
val itemPepperoniSlice_6215 = ItemSkillId(6215)
val itemPeppSlice1_6216 = ItemSkillId(6216)
val itemAnchovySlice_6217 = ItemSkillId(6217)
val itemAnchSlice1_6218 = ItemSkillId(6218)
val itemWarthogStewpot_6219 = ItemSkillId(6219)
val itemPrmWtStewpot_6220 = ItemSkillId(6220)
val itemPrzWtStewpot_6221 = ItemSkillId(6221)
val itemWarthogMeat_6222 = ItemSkillId(6222)
val itemCSnowCone_6223 = ItemSkillId(6223)
val itemASnowCone_6224 = ItemSkillId(6224)
val itemCCoalescence_6225 = ItemSkillId(6225)
val itemPixioche_6226 = ItemSkillId(6226)
val itemPYggShardI_6227 = ItemSkillId(6227)
val itemPYggShardII_6228 = ItemSkillId(6228)
val itemPYggShardIII_6229 = ItemSkillId(6229)
val itemPYggShardIV_6230 = ItemSkillId(6230)
val itemPYggShardV_6231 = ItemSkillId(6231)
val itemRYggShardI_6232 = ItemSkillId(6232)
val itemRYggShardII_6233 = ItemSkillId(6233)
val itemRYggShardIII_6234 = ItemSkillId(6234)
val itemRYggShardIV_6235 = ItemSkillId(6235)
val itemRYggShardV_6236 = ItemSkillId(6236)
val itemAsYggShI_6237 = ItemSkillId(6237)
val itemAsYggShII_6238 = ItemSkillId(6238)
val itemAsYggShIII_6239 = ItemSkillId(6239)
val itemAsYggShIV_6240 = ItemSkillId(6240)
val itemAsYggShV_6241 = ItemSkillId(6241)
val itemPhloxYggziI_6242 = ItemSkillId(6242)
val itemPhloxYggziII_6243 = ItemSkillId(6243)
val itemPhloxYggziIII_6244 = ItemSkillId(6244)
val itemPhloxYggziIV_6245 = ItemSkillId(6245)
val itemPhloxYggziV_6246 = ItemSkillId(6246)
val itemRussetYggziI_6247 = ItemSkillId(6247)
val itemRussetYggziII_6248 = ItemSkillId(6248)
val itemRussetYggziIII_6249 = ItemSkillId(6249)
val itemRussetYggziIV_6250 = ItemSkillId(6250)
val itemRussetYggziV_6251 = ItemSkillId(6251)
val itemAsterYggziI_6252 = ItemSkillId(6252)
val itemAsterYggziII_6253 = ItemSkillId(6253)
val itemAsterYggziIII_6254 = ItemSkillId(6254)
val itemAsterYggziIV_6255 = ItemSkillId(6255)
val itemAsterYggziV_6256 = ItemSkillId(6256)
val itemJungleNectar_6257 = ItemSkillId(6257)
val itemShiromochi_6258 = ItemSkillId(6258)
val itemShiromochi1_6259 = ItemSkillId(6259)
val itemAkamochi_6260 = ItemSkillId(6260)
val itemAkamochi1_6261 = ItemSkillId(6261)
val itemKusamochi_6262 = ItemSkillId(6262)
val itemKusamochi1_6263 = ItemSkillId(6263)
val itemFrayedSackH1_6264 = ItemSkillId(6264)
val itemToolbagRanka_6265 = ItemSkillId(6265)
val itemToolbagFuru_6266 = ItemSkillId(6266)
val itemAgedBoxBayld_6267 = ItemSkillId(6267)
val itemKomanezumi_6268 = ItemSkillId(6268)
val itemEminentQuiver_6269 = ItemSkillId(6269)
val itemEmBoltQuiver_6270 = ItemSkillId(6270)
val itemEmBulPouch_6271 = ItemSkillId(6271)
val itemFriedPopoto_6272 = ItemSkillId(6272)
val itemFriedPopoto1_6273 = ItemSkillId(6273)
val itemPukatriceEgg_6274 = ItemSkillId(6274)
val itemPukatriceEgg1_6275 = ItemSkillId(6275)
val itemDfriedShrimp_6276 = ItemSkillId(6276)
val itemDfrShrimp1_6277 = ItemSkillId(6277)
val itemAbrBoltQuiver_6278 = ItemSkillId(6278)
val itemRigBoltQuiver_6279 = ItemSkillId(6279)
val itemRaKaznarQuiver_6280 = ItemSkillId(6280)
val itemRaBoltQuiver_6281 = ItemSkillId(6281)
val itemRaBulPouch_6282 = ItemSkillId(6282)
val itemVelkkCoffer_6283 = ItemSkillId(6283)
val itemGrVelkkCoffer_6284 = ItemSkillId(6284)
val itemYmmrUlCo_6285 = ItemSkillId(6285)
val itemYmGrCoffer_6286 = ItemSkillId(6286)
val itemIgnorMntsCo_6287 = ItemSkillId(6287)
val itemIgGrCoffer_6288 = ItemSkillId(6288)
val itemDursVikesCo_6289 = ItemSkillId(6289)
val itemDuGrCoffer_6290 = ItemSkillId(6290)
val itemTrylWujsCo_6291 = ItemSkillId(6291)
val itemTrGrCoffer_6292 = ItemSkillId(6292)
val itemLiijVoksCo_6293 = ItemSkillId(6293)
val itemLiGrCoffer_6294 = ItemSkillId(6294)
val itemGramkDrCoffer_6295 = ItemSkillId(6295)
val itemGrGrCoffer_6296 = ItemSkillId(6296)
val itemJujiShPouch_6297 = ItemSkillId(6297)
val itemManjiShPouch_6298 = ItemSkillId(6298)
val itemShPouch_6299 = ItemSkillId(6299)
val itemKogaShPouch_6300 = ItemSkillId(6300)
val itemTogaShPouch_6301 = ItemSkillId(6301)
val itemFumaShPouch_6302 = ItemSkillId(6302)
val itemIgaShPouch_6303 = ItemSkillId(6303)
val itemRopShPouch_6304 = ItemSkillId(6304)
val itemRoSh1Pouch_6305 = ItemSkillId(6305)
val itemHapShPouch_6306 = ItemSkillId(6306)
val itemHaSh1Pouch_6307 = ItemSkillId(6307)
val itemHacShPouch_6308 = ItemSkillId(6308)
val itemSupShPouch_6309 = ItemSkillId(6309)
val itemGashBoltQuiver_6310 = ItemSkillId(6310)
val itemDecBulPouch_6311 = ItemSkillId(6311)
val itemHaroldsCoffer_6312 = ItemSkillId(6312)
val itemBelindasCoffer_6313 = ItemSkillId(6313)
val itemPitrivsCoffer_6314 = ItemSkillId(6314)
val itemBaldurnosCoffer_6315 = ItemSkillId(6315)
val itemMabelsCoffer_6316 = ItemSkillId(6316)
val itemImperatorsCoffer_6317 = ItemSkillId(6317)
val itemNinlilsCoffer_6318 = ItemSkillId(6318)
val itemAbyssdiversCoffer_6319 = ItemSkillId(6319)
val itemIntuilasCoffer_6320 = ItemSkillId(6320)
val itemArthrosCoffer_6321 = ItemSkillId(6321)
val itemOrcfeltrapsCoffer_6322 = ItemSkillId(6322)
val itemJillsCoffer_6323 = ItemSkillId(6323)
val itemJoyoussCoffer_6324 = ItemSkillId(6324)
val itemStrixsCoffer_6325 = ItemSkillId(6325)
val itemWarbladesCoffer_6326 = ItemSkillId(6326)
val itemArkesCoffer_6327 = ItemSkillId(6327)
val itemLargantuasCoffer_6328 = ItemSkillId(6328)
val itemBeistsCoffer_6329 = ItemSkillId(6329)
val itemMalatrixsCoffer_6330 = ItemSkillId(6330)
val itemVelozsCoffer_6331 = ItemSkillId(6331)
val itemMendersCoffer_6332 = ItemSkillId(6332)
val itemTranslucentSalpa_6333 = ItemSkillId(6333)
val itemRaShellfish_6334 = ItemSkillId(6334)
val itemWhiteLobster_6335 = ItemSkillId(6335)
val itemBonefish_6336 = ItemSkillId(6336)
val itemThysanopeltis_6337 = ItemSkillId(6337)
val itemCameroceras_6338 = ItemSkillId(6338)
val itemRolanDaifuku_6339 = ItemSkillId(6339)
val itemRolanDaifuku1_6340 = ItemSkillId(6340)
val itemBeanDaifuku_6341 = ItemSkillId(6341)
val itemBeanDaifuku1_6342 = ItemSkillId(6342)
val itemGrapeDaifuku_6343 = ItemSkillId(6343)
val itemGrapeDaifuku1_6344 = ItemSkillId(6344)
val itemFrayedSackH2_6345 = ItemSkillId(6345)
val itemFrayedSackPul_6346 = ItemSkillId(6346)
val itemPromathianTunes_6347 = ItemSkillId(6347)
val itemAdoulinianTunes_6348 = ItemSkillId(6348)
val itemMakelsGrabBag_6349 = ItemSkillId(6349)
val itemSamanCoffer_6350 = ItemSkillId(6350)
val itemHeiligtumsCoffer_6351 = ItemSkillId(6351)
val itemDoumasCoffer_6352 = ItemSkillId(6352)
val itemUropygidsCoffer_6353 = ItemSkillId(6353)
val itemVedrfolnirsCoffer_6354 = ItemSkillId(6354)
val itemStiBulPouch_6355 = ItemSkillId(6355)
val itemTiyanaksCoffer_6356 = ItemSkillId(6356)
val itemImmaniCoffer_6357 = ItemSkillId(6357)
val itemMuutsCoffer_6358 = ItemSkillId(6358)
val itemCamaCoffer_6359 = ItemSkillId(6359)
val itemVososCoffer_6360 = ItemSkillId(6360)
val itemMephitassCoffer_6361 = ItemSkillId(6361)
val itemCocasCoffer_6362 = ItemSkillId(6362)
val itemAyapecsCoffer_6363 = ItemSkillId(6363)
val itemSpectersCoffer_6364 = ItemSkillId(6364)
val itemAzraelsCoffer_6365 = ItemSkillId(6365)
val itemBorealissCoffer_6366 = ItemSkillId(6366)
val itemCodexofEtchings_6367 = ItemSkillId(6367)
val itemGeomancerDie_6368 = ItemSkillId(6368)
val itemRuneFencerDie_6369 = ItemSkillId(6369)
val itemFrayedSackMel_6370 = ItemSkillId(6370)
val itemQuickBlade_6371 = ItemSkillId(6371)
val itemLordofUlbuka_6372 = ItemSkillId(6372)
val itemAncientCarp_6373 = ItemSkillId(6373)
val itemDraTabernacle_6374 = ItemSkillId(6374)
val itemPhanSerpent_6375 = ItemSkillId(6375)
val itemTusoteuthisLonga_6376 = ItemSkillId(6376)
val itemImperialChair_6377 = ItemSkillId(6377)
val itemDecorativeChair_6378 = ItemSkillId(6378)
val itemOrnateStool_6379 = ItemSkillId(6379)
val itemRefinedChair_6380 = ItemSkillId(6380)
val itemFishermansFeast_6381 = ItemSkillId(6381)
val itemGarbagesCoffer_6382 = ItemSkillId(6382)
val itemBakunawasCoffer_6383 = ItemSkillId(6383)
val itemClawberrysCoffer_6384 = ItemSkillId(6384)
val itemVermillionsCoffer_6385 = ItemSkillId(6385)
val itemVolatilesCoffer_6386 = ItemSkillId(6386)
val itemMhuufyasCoffer_6387 = ItemSkillId(6387)
val itemGGrenadesCoffer_6388 = ItemSkillId(6388)
val itemVidmapiresCoffer_6389 = ItemSkillId(6389)
val itemCenturiosCoffer_6390 = ItemSkillId(6390)
val itemSiltPouch_6391 = ItemSkillId(6391)
val itemBeadPouch_6392 = ItemSkillId(6392)
val itemPorxiePork_6393 = ItemSkillId(6393)
val itemPorkCutlet_6394 = ItemSkillId(6394)
val itemPorkCutlet1_6395 = ItemSkillId(6395)
val itemCutletSandwich_6396 = ItemSkillId(6396)
val itemCutletSandwich1_6397 = ItemSkillId(6397)
val itemArenaFireflies_6398 = ItemSkillId(6398)
val itemSaviorsTonic_6399 = ItemSkillId(6399)
val itemMirrorsTonic_6400 = ItemSkillId(6400)
val itemMonetasTonic_6401 = ItemSkillId(6401)
val itemSteadfastTonic_6402 = ItemSkillId(6402)
val itemTolbasCoffer_6403 = ItemSkillId(6403)
val itemHidhaeggsCoffer_6404 = ItemSkillId(6404)
val itemSovereignsCoffer_6405 = ItemSkillId(6405)
val itemPorkCutletBowl_6406 = ItemSkillId(6406)
val itemPorkCutletBowl1_6407 = ItemSkillId(6407)
val itemPortableContainer_6408 = ItemSkillId(6408)
val itemEphramadThrone_6409 = ItemSkillId(6409)
val itemShadowThrone_6410 = ItemSkillId(6410)
val itemChocoboChair_6411 = ItemSkillId(6411)
val itemLeafBench_6412 = ItemSkillId(6412)
val itemAstralCube_6413 = ItemSkillId(6413)
val itemPorxieQuiver_6414 = ItemSkillId(6414)
val itemSekiShPouch_6415 = ItemSkillId(6415)
val itemBehemothMeat_6416 = ItemSkillId(6416)
val itemDivineQuiver_6417 = ItemSkillId(6417)
val itemBerylliumQuiver_6418 = ItemSkillId(6418)
val itemRaeticQuiver_6419 = ItemSkillId(6419)
val itemVoluspaQuiver_6420 = ItemSkillId(6420)
val itemDivBoltQuiver_6427 = ItemSkillId(6427)
val itemBerBoltQuiver_6428 = ItemSkillId(6428)
val itemVolBoltQuiver_6429 = ItemSkillId(6429)
val itemDivBulPouch_6437 = ItemSkillId(6437)
val itemVolBulPouch_6438 = ItemSkillId(6438)
val itemSasuShPouch_6447 = ItemSkillId(6447)
val itemSaShPouch1_6448 = ItemSkillId(6448)
val itemDateShPouch_6449 = ItemSkillId(6449)
val itemShadowLordTunes_6456 = ItemSkillId(6456)
val itemFlarelet_6457 = ItemSkillId(6457)
val itemSoyRamen_6458 = ItemSkillId(6458)
val itemSoyRamen1_6459 = ItemSkillId(6459)
val itemMisoRamen_6460 = ItemSkillId(6460)
val itemMisoRamen1_6461 = ItemSkillId(6461)
val itemSaltRamen_6462 = ItemSkillId(6462)
val itemSaltRamen1_6463 = ItemSkillId(6463)
val itemBehemothSteak_6464 = ItemSkillId(6464)
val itemBeheSteak1_6465 = ItemSkillId(6465)
val itemMisoSoup_6466 = ItemSkillId(6466)
val itemMisoSoup1_6467 = ItemSkillId(6467)
val itemSublimeSushi_6468 = ItemSkillId(6468)
val itemSublimeSushi1_6469 = ItemSkillId(6469)
val itemOden_6470 = ItemSkillId(6470)
val itemOden1_6471 = ItemSkillId(6471)
val itemSuperRevitalizer_6473 = ItemSkillId(6473)
val itemPoisonBuffer_6474 = ItemSkillId(6474)
val itemLucidWingsII_6475 = ItemSkillId(6475)
val itemVirusBuffer_6476 = ItemSkillId(6476)
val itemCharmBuffer_6477 = ItemSkillId(6477)
val itemCurseBuffer_6478 = ItemSkillId(6478)
val itemTumultsCoffer_6479 = ItemSkillId(6479)
val itemThubansCoffer_6480 = ItemSkillId(6480)
val itemSaramasCoffer_6481 = ItemSkillId(6481)
val itemShedusCoffer_6482 = ItemSkillId(6482)
val itemGlazemanesCoffer_6483 = ItemSkillId(6483)
val itemCelinesCoffer_6484 = ItemSkillId(6484)
val itemBambroxsCoffer_6485 = ItemSkillId(6485)
val itemFrayedSackPel_6486 = ItemSkillId(6486)
val itemFrayedSackFer_6487 = ItemSkillId(6487)
val itemFrayedSackTau_6488 = ItemSkillId(6488)
val itemFarEastPuffer_6489 = ItemSkillId(6489)
val itemFortuneFruits_6498 = ItemSkillId(6498)
val itemPatioDesignPlans_6499 = ItemSkillId(6499)
val itemAbdhaljsSeal_6500 = ItemSkillId(6500)
val itemKonjakTuber_6501 = ItemSkillId(6501)
val itemKonjak_6502 = ItemSkillId(6502)
val itemDaikon_6503 = ItemSkillId(6503)
val itemChikuwa_6505 = ItemSkillId(6505)
val itemPyreCrystal_6506 = ItemSkillId(6506)
val itemFrostCrystal_6507 = ItemSkillId(6507)
val itemVortexCrystal_6508 = ItemSkillId(6508)
val itemGeoCrystal_6509 = ItemSkillId(6509)
val itemBoltCrystal_6510 = ItemSkillId(6510)
val itemFluidCrystal_6511 = ItemSkillId(6511)
val itemGlimmerCrystal_6512 = ItemSkillId(6512)
val itemShadowCrystal_6513 = ItemSkillId(6513)
val itemReisenjimaCage_6514 = ItemSkillId(6514)
val itemLargeTail_6515 = ItemSkillId(6515)
val itemLargeStone_6516 = ItemSkillId(6516)
val itemLargeLeaf_6517 = ItemSkillId(6517)
val itemMorbolLatte_6518 = ItemSkillId(6518)
val itemFetidCurry_6519 = ItemSkillId(6519)
val itemRancidCoffee_6520 = ItemSkillId(6520)
val itemDecIngrid_6521 = ItemSkillId(6521)
val itemDecDarrcuiln_6522 = ItemSkillId(6522)
val itemDecArciela_6523 = ItemSkillId(6523)
val itemDecMorimar_6524 = ItemSkillId(6524)
val itemDecRosulatia_6525 = ItemSkillId(6525)
val itemDecTeodor_6526 = ItemSkillId(6526)
val itemDecAugust_6527 = ItemSkillId(6527)
val itemDecSajjaka_6528 = ItemSkillId(6528)
val itemDecArcielaII_6529 = ItemSkillId(6529)
val itemRPickledRTail_6530 = ItemSkillId(6530)
val itemBlackHourglass_6531 = ItemSkillId(6531)
val itemCofferPluton_6532 = ItemSkillId(6532)
val itemCofferBeitetsu_6533 = ItemSkillId(6533)
val itemCofferBoulder_6534 = ItemSkillId(6534)
val itemPungentPowderII_6535 = ItemSkillId(6535)
val itemNewYearsPouch_6536 = ItemSkillId(6536)
val itemPungentPowderIII_6537 = ItemSkillId(6537)
val itemAltanasRepast_6538 = ItemSkillId(6538)
val itemAltanasRepast1_6539 = ItemSkillId(6539)
val itemAltanasRepast2_6540 = ItemSkillId(6540)
val itemWornSackSS1_6541 = ItemSkillId(6541)
val itemWornSackSS2_6542 = ItemSkillId(6542)
val itemWornSackLS1_6543 = ItemSkillId(6543)
val itemWornSackLS2_6544 = ItemSkillId(6544)
val itemWornSackDS1_6545 = ItemSkillId(6545)
val itemWornSackDS2_6546 = ItemSkillId(6546)
val itemWornSackST1_6547 = ItemSkillId(6547)
val itemWornSackST2_6548 = ItemSkillId(6548)
val itemWornSackLT1_6549 = ItemSkillId(6549)
val itemWornSackLT2_6550 = ItemSkillId(6550)
val itemWornSackDT1_6551 = ItemSkillId(6551)
val itemWornSackDT2_6552 = ItemSkillId(6552)
val itemWornSackSD1_6553 = ItemSkillId(6553)
val itemWornSackSD2_6554 = ItemSkillId(6554)
val itemWornSackLD1_6555 = ItemSkillId(6555)
val itemWornSackLD2_6556 = ItemSkillId(6556)
val itemWornSackDD1_6557 = ItemSkillId(6557)
val itemWornSackDD2_6558 = ItemSkillId(6558)
val itemWornSackSO1_6559 = ItemSkillId(6559)
val itemWornSackSO2_6560 = ItemSkillId(6560)
val itemWornSackLO1_6561 = ItemSkillId(6561)
val itemWornSackLO2_6562 = ItemSkillId(6562)
val itemWornSackDO1_6563 = ItemSkillId(6563)
val itemWornSackDO2_6564 = ItemSkillId(6564)
val itemPerSnowCone_6565 = ItemSkillId(6565)
val itemBonanzaBiscuit_6566 = ItemSkillId(6566)
val itemTropicalCrepe_6567 = ItemSkillId(6567)
val itemCrepedesRois_6568 = ItemSkillId(6568)
val itemSlowII_6569 = ItemSkillId(6569)
val itemParalyzeII_6570 = ItemSkillId(6570)
val itemPhalanxII_6571 = ItemSkillId(6571)
val itemCofferSAst_6572 = ItemSkillId(6572)
val itemCofferMAst_6573 = ItemSkillId(6573)
val itemVConShard_6574 = ItemSkillId(6574)
val itemCheesestkSand_6575 = ItemSkillId(6575)
val itemRolTurkey_6576 = ItemSkillId(6576)
val itemClamChowder_6577 = ItemSkillId(6577)
val itemPopotoGratin_6578 = ItemSkillId(6578)
val itemBehemothSand_6579 = ItemSkillId(6579)
val itemRusticFish_6580 = ItemSkillId(6580)
val itemCornbread_6581 = ItemSkillId(6581)
val itemWSnowCone_6582 = ItemSkillId(6582)
val itemSaltedDflyTrout_6583 = ItemSkillId(6583)
val itemGrilledDflyTrout_6584 = ItemSkillId(6584)
val itemChGrabBag_6585 = ItemSkillId(6585)
val itemSusuroonsGift_6586 = ItemSkillId(6586)
val itemLuScaleBox_6590 = ItemSkillId(6590)
val itemLuHideBox_6591 = ItemSkillId(6591)
val itemLWingBox_6592 = ItemSkillId(6592)
val itemLLuScaleBox_6593 = ItemSkillId(6593)
val itemLLuHideBox_6594 = ItemSkillId(6594)
val itemLLuWingBox_6595 = ItemSkillId(6595)
val itemMoglophone_6596 = ItemSkillId(6596)
val itemMaatsConcoc_6597 = ItemSkillId(6597)
val itemMaatsMix_6598 = ItemSkillId(6598)
val itemEggSandwich_6599 = ItemSkillId(6599)
val itemEggSand1_6600 = ItemSkillId(6600)
val itemOmSandwich_6601 = ItemSkillId(6601)
val itemOmSand1_6602 = ItemSkillId(6602)
val itemRolanberry854_6603 = ItemSkillId(6603)
val itemWhRolanberry_6604 = ItemSkillId(6604)
val itemRiWhRolan_6605 = ItemSkillId(6605)
val itemBBVintage_6606 = ItemSkillId(6606)
val itemMoglophoneII_6607 = ItemSkillId(6607)
val itemMoogleAmp_6608 = ItemSkillId(6608)
val itemPopoconQueso_6609 = ItemSkillId(6609)
val itemPopoconQue1_6610 = ItemSkillId(6610)
val itemSeafoodGratin_6611 = ItemSkillId(6611)
val itemSeaGratin1_6612 = ItemSkillId(6612)
val itemHoptoad_6613 = ItemSkillId(6613)
val itemOldCase_6614 = ItemSkillId(6614)
val itemOldCase1_6615 = ItemSkillId(6615)
val itemOldCase2_6616 = ItemSkillId(6616)
val itemEarringWAR_6617 = ItemSkillId(6617)
val itemEarWAR1_6618 = ItemSkillId(6618)
val itemEarWAR2_6619 = ItemSkillId(6619)
val itemEarringMNK_6620 = ItemSkillId(6620)
val itemEarMNK1_6621 = ItemSkillId(6621)
val itemEarMNK2_6622 = ItemSkillId(6622)
val itemEarringWHM_6623 = ItemSkillId(6623)
val itemEarWHM1_6624 = ItemSkillId(6624)
val itemEarWHM2_6625 = ItemSkillId(6625)
val itemEarringBLM_6626 = ItemSkillId(6626)
val itemEarBLM1_6627 = ItemSkillId(6627)
val itemEarBLM2_6628 = ItemSkillId(6628)
val itemEarringRDM_6629 = ItemSkillId(6629)
val itemEarRDM1_6630 = ItemSkillId(6630)
val itemEarRDM2_6631 = ItemSkillId(6631)
val itemEarringTHF_6632 = ItemSkillId(6632)
val itemEarTHF1_6633 = ItemSkillId(6633)
val itemEarTHF2_6634 = ItemSkillId(6634)
val itemEarringPLD_6635 = ItemSkillId(6635)
val itemEarPLD1_6636 = ItemSkillId(6636)
val itemEarPLD2_6637 = ItemSkillId(6637)
val itemEarringDRK_6638 = ItemSkillId(6638)
val itemEarDRK1_6639 = ItemSkillId(6639)
val itemEarDRK2_6640 = ItemSkillId(6640)
val itemEarringBST_6641 = ItemSkillId(6641)
val itemEarBST1_6642 = ItemSkillId(6642)
val itemEarBST2_6643 = ItemSkillId(6643)
val itemEarringBRD_6644 = ItemSkillId(6644)
val itemEarBRD1_6645 = ItemSkillId(6645)
val itemEarBRD2_6646 = ItemSkillId(6646)
val itemEarringRNG_6647 = ItemSkillId(6647)
val itemEarRNG1_6648 = ItemSkillId(6648)
val itemEarRNG2_6649 = ItemSkillId(6649)
val itemEarringSAM_6650 = ItemSkillId(6650)
val itemEarSAM1_6651 = ItemSkillId(6651)
val itemEarSAM2_6652 = ItemSkillId(6652)
val itemEarringNIN_6653 = ItemSkillId(6653)
val itemEarNIN1_6654 = ItemSkillId(6654)
val itemEarNIN2_6655 = ItemSkillId(6655)
val itemEarringDRG_6656 = ItemSkillId(6656)
val itemEarDRG1_6657 = ItemSkillId(6657)
val itemEarDRG2_6658 = ItemSkillId(6658)
val itemEarringSMN_6659 = ItemSkillId(6659)
val itemEarSMN1_6660 = ItemSkillId(6660)
val itemEarSMN2_6661 = ItemSkillId(6661)
val itemEarringBLU_6662 = ItemSkillId(6662)
val itemEarBLU1_6663 = ItemSkillId(6663)
val itemEarBLU2_6664 = ItemSkillId(6664)
val itemEarringCOR_6665 = ItemSkillId(6665)
val itemEarCOR1_6666 = ItemSkillId(6666)
val itemEarCOR2_6667 = ItemSkillId(6667)
val itemEarringPUP_6668 = ItemSkillId(6668)
val itemEarPUP1_6669 = ItemSkillId(6669)
val itemEarPUP2_6670 = ItemSkillId(6670)
val itemEarringDNC_6671 = ItemSkillId(6671)
val itemEarDNC1_6672 = ItemSkillId(6672)
val itemEarDNC2_6673 = ItemSkillId(6673)
val itemEarringSCH_6674 = ItemSkillId(6674)
val itemEarSCH1_6675 = ItemSkillId(6675)
val itemEarSCH2_6676 = ItemSkillId(6676)
val itemEarringGEO_6677 = ItemSkillId(6677)
val itemEarGEO1_6678 = ItemSkillId(6678)
val itemEarGEO2_6679 = ItemSkillId(6679)
val itemEarringRUN_6680 = ItemSkillId(6680)
val itemEarRUN1_6681 = ItemSkillId(6681)
val itemEarRUN2_6682 = ItemSkillId(6682)
val itemPorcelainMine_6683 = ItemSkillId(6683)
val itemPopperII_6684 = ItemSkillId(6684)
val itemObsidWing_6685 = ItemSkillId(6685)
val itemGyudon_6686 = ItemSkillId(6686)
val itemGyudon1_6687 = ItemSkillId(6687)
val itemChaKnapsack_6688 = ItemSkillId(6688)
val itemLargeWhTail_6689 = ItemSkillId(6689)
val itemStarlightTunes_6690 = ItemSkillId(6690)
val itemMapitotoTunes_6691 = ItemSkillId(6691)
val itemExperFluid_6692 = ItemSkillId(6692)
val itemImpishBox_6693 = ItemSkillId(6693)
val itemChocoChairII_6694 = ItemSkillId(6694)
val itemAdenBench_6695 = ItemSkillId(6695)
val itemNearEastTunes_6696 = ItemSkillId(6696)
val itemInstantReraiseIII_6697 = ItemSkillId(6697)
val itemWhitegateGlyph_6698 = ItemSkillId(6698)
val itemEvanessence_6699 = ItemSkillId(6699)
val itemMoogleMemo_6700 = ItemSkillId(6700)
val itemLamiaPowder_6701 = ItemSkillId(6701)
val itemPeisteConc_6702 = ItemSkillId(6702)
val itemDivineTunes_6704 = ItemSkillId(6704)
